/*
* @Author: chillylight
* @Date:   2019-10-17 09:26:25
* @Last Modified by:   chillylight
* @Last Modified time: 2021-01-14 16:04:45
*/
import _comMeds from '@src/assets/js/common.js';
import _userMeds from "@src/assets/js/user.js";
import '@src/assets/js/table.js';
import './index.scss';
import _tran from '@src/assets/js/server/tran-server.js';
import _score from '@src/assets/js/server/score-server.js';
import _vip from '@src/assets/js/server/vip-server.js';
import _pdf from '@src/assets/js/server/pdf-server.js';
import _ofd from '@src/assets/js/server/ofd-server.js';
import _pay from '@src/assets/js/server/pay-server.js';
import _tranCommon from '@src/assets/js/tranCommon.js';
import _feedBackBox from '@src/assets/js/feedBackBox.js';
import _mall from '@src/assets/js/server/mall-server.js';
import _allPayBox from '@src/assets/js/totalUse/allPayBox.js';
import FormData from 'form-data';
import QRCode from 'qrcodejs2';
import _downFile from "@src/assets/js/totalUse/downFiles.js";
import _headMask from "@src/assets/js/server/head-mask.js"

_userMeds.init();


var page = {
	data:{
		table_timer : [],
		chooseIds:[],
		node:1, // 1:我的翻译，2:回收站
		watchDetailId:'',
		rubbishTime:'-', // 回收站存储时常
		timeReqCount:0,
		isChooseExprice:0, // 0为未选中过期文件，1为选中
		expireCount:0, // 要过期的文档数
        recentExpireDay: '',  //要过期的文档时间
		isChooseSystemExprice: '', // 默认为全部
		totalRestoreDay: 0,
		chooseSource: [],
		userCoins: '', // 用户轻寻豆
		needCoins: '', // 用户至少需要消耗的轻寻豆
		recoverDaysArr: [],
		chooseStatus: [], //图片翻译状态
        timer: null, // 单个定时器
        typeId: '', //0有权益1没有权益
        sum: '0',
        chooseId: '',
        isChoosed: 0,
		isShowSingle: 1,  // 0：不展示 1:展示
		transType: 0, // 点击文件是否用deepl引擎 0通用 1deepl
		chooseTransTy: '', // ''全部 0通用 1deepL 2google 3openai
	},
	init: function(){
	  this.onLoad();
	  this.bindEvent();
		window.onbeforeunload=function(e){ 
			sessionStorage.setItem('ab_page','')
			sessionStorage.setItem('ab_a_wu', '')
		} 
	},
	onLoad : function(){
		_comMeds.countLink(3);
		if(_comMeds.isLogin()){
			this.getLevel();
			this.getDocExpireCount();
			this.isShowSinglePay();
			this.getURLcurrent()
			this.getMyTranslate(1);

		}else{
			$('.user-content').hide()
			$('.comm-empty').show()
			this.unLogin();
		}
		this.addFeedBack();
	},
	bindEvent : function(){
		let _this = this;
		// 点击切换我的翻译，回收站
		$(".top-toggle ul>li").click(function(e){
			let type = $(this).data("type");
			_this.data.node = type;
			_this.data.chooseIds = [];
			_this.data.chooseSource = [];
			$(this).addClass("active").siblings().removeClass("active");
			// let dataTableInstance = $('.maintable').DataTable()
			// dataTableInstance.clear().draw(); // 清除表格数据（但不清除表格结构）  // 不能.draw 触发多余事件
      // dataTableInstance.destroy();

			$('.maintable').DataTable().clear().destroy();
			
			$('.maintable .pdf-file-source').removeClass('pdf-file-source');
			$(".all-timeout-tip").hide();
			$(".erji-huishou").hide();
			$('.search-box .search-input').val('');
			$('.pdf-file-source i').addClass('icondown').removeClass('iconup');

			if ($(".timeout-tip .is-check-guoqi").hasClass("iconxuanzhong1")) {
				$(".timeout-tip .is-check-guoqi").removeClass("iconxuanzhong1").addClass("iconoval");
			}

			$('.maintable .allFile').removeClass('allFile');
			$('.allFile i').addClass('icondown').removeClass('iconup');
			// $(".erji-myfile").hide();

			if (type == 3) {
                _comMeds.countLink(119,14)
				_this.getImgTranList(type);
				_this.getDocExpireCount();
			}else if(type == 7){  // 格式转换
                _comMeds.countLink(115,14)
				_this.getPdfList();
				_this.getDocExpireCount();
			} else if(type == 2){  // 回收站
                _comMeds.countLink(117,14)
				_this.getWillRestoreDoc();
				_this.getMyRecycleList(1);
				$('.erji-huishou div:first-child').addClass('active').siblings().removeClass('active');
			}else{
                _comMeds.countLink(118,14)
				_this.getDocExpireCount();
				_this.getMyTranslate(type);
			}
			for(var i = 0; i <= _this.data.table_timer.length; i++){
				clearInterval(_this.data.table_timer[i]);   
			}
			e.stopPropagation();
		})
		// 点击二级回收
        $(".erji-huishou>div").click(function(e){
			$(this).parents("li").addClass("active").siblings().removeClass("active");
			$(this).addClass("active").siblings().removeClass("active");
			$('.maintable').DataTable().destroy();
			let type = $(this).data("type");
			_this.getMyRecycleList(type);
			$('.erji-huishou').slideUp();
			e.stopPropagation();
		})
		// 点击二级我的文件
		$("body").on('click','.erji-myfile>div',function(e){
			$(this).parents("li").addClass("active").siblings().removeClass("active");
			$(this).addClass("active").siblings().removeClass("active");
			$('.maintable').DataTable().destroy();
			let type = $(this).data("type");
			_this.data.chooseTransTy = type;
			_this.getMyTranslate(1);
			$('.erji-myfile').slideUp();
			e.stopPropagation();
		})
		// 点击全选
		$("body").on('change','.total-check',function(){
			let is_check_all = $(".total-check").prop("checked");
			let choose_id = '';

			if (is_check_all) {
				$(".check-item input.can-choose").prop("checked",true);
				$.each($(".check-item input.can-choose"),function(i,item){
					choose_id = $(item).data("id");
					if ($.inArray(choose_id,_this.data.chooseIds)!=-1) {
						_this.data.chooseIds.splice(choose_id, 1);
						if(_this.data.node == 2){
							_this.data.chooseSource.splice(choose_id, 1);
						}
						if(_this.data.node == 3){
                            _this.data.chooseStatus.splice(choose_id, 1);
						}
					}else{
						_this.data.chooseIds.push(choose_id);
						if(_this.data.node == 2) {
							let choose_source = $(item).data("source");
							_this.data.chooseSource.push(choose_source);
						}
						if(_this.data.node == 3){
							let choose_status =  $(item).data("status");
							_this.data.chooseStatus.push(choose_status);
						}
					}
				})
			}else{
				$.each($(".check-item input.can-choose"),function(i,item){
					choose_id = $(item).data("id");
					let id_index = $.inArray(choose_id,_this.data.chooseIds);
					if (id_index != -1) {
						_this.data.chooseIds.splice(id_index, 1);
						if(_this.data.node == 2){
							_this.data.chooseSource.splice(id_index, 1);
						}
						if(_this.data.node == 3){
							_this.data.chooseStatus.splice(id_index, 1);
						}
					}else{
						_this.data.chooseIds.push(choose_id);
						if(_this.data.node == 2){
							let choose_source = $(item).data("source");
							_this.data.node.push(choose_source);
						}
						if(_this.data.node == 3){
							let choose_status =  $(item).data("status");
							_this.data.chooseStatus.push(choose_status);
						}
					}
				})
				$(".check-item input.can-choose").prop("checked",false);
			}

			_this.mulOperate(_this.data.chooseIds);
		})

		// 点击阅读
		$("body").on('click','.read-doc',function(){
			let id = $(this).parent("p").data("id");
            _comMeds.messageDataFunnel(4)
			_this.readDoc(id);
			if($(this).parent("p").data("pagecount") > 20){
				localStorage.setItem("pagefromtype","mytran")
			}
		})
		$("body").on('click','.reads-doc',function(){
			let id = $(this).parent("p").data("id");
			let bilingualcontrol = $(this).parent("p").data("bilingualcontrol");
            _comMeds.messageDataFunnel(4)
			if(bilingualcontrol){ // 1 同文档
				_this.readDocs(id);
			}else{
				_this.readDocsPdf(id);
			}
			
			if($(this).parent("p").data("pagecount") > 20){
				localStorage.setItem("pagefromtype","mytran")
			}
		})
        // 点击支付
		// $("body").on('click','.paySuccess',function(){
		// 	let id = $(this).parent("p").data("id");
        //     console.log(id)
        //     _tranCommon.readCheckScore(id)

		// })
		// 阅读图片
		$("body").on('click','.read-img',function(){
			let id = $(this).parent("p").data("id");
			_this.readImg(id);
		})
		// 点击下载
		$("body").on('click','.down-doc',function(){
			// _comMeds.countLink(377,88)
			// _comMeds.countLink(615,103,$(this).parent("p").data("id"))
			// let id = $(this).parent("p").data("id").toString();
			// let doctype = $(this).parent("p").data("type");
			// _downFile.choiceFormat(id, doctype);
			
			// _comMeds.countLink(377,88)
			// _comMeds.countLink(615,103,$(this).parent("p").data("id"))
			sessionStorage.removeItem('data_topbtn')
			_comMeds.countnewLink('v0030');
			let id = $(this).parent("p").data("id").toString();
			let doctype = $(this).parent("p").data("type");
			let pagecount = $(this).parent("p").data("pagecount");
			let datafree = $(this).data('free')
			_this.data.transType = $(this).parent("p").data("transtype");
			sessionStorage.setItem('ab_page',pagecount+'_'+2)
			sessionStorage.setItem('ab_a_wu', 1)
			console.log('free-data');
			console.log(datafree);

			if (_this.data.transType == 1) {
				sessionStorage.setItem('deeplModel', '1')
			} else {
				sessionStorage.removeItem('deeplModel')
			}
			
			

			let params = {
				pageCount: pagecount,
				id: id,
				doctype: doctype,
			}
			if(_this.data.transType){
				sessionStorage.setItem("novaeHomines",'7')
			}else{
				// sessionStorage.setItem("novaeHomines",3)
			}
			if($(this).attr('data-free') == 1 && pagecount > 20){
				let subData = {
					tid:id,
				};
				_tran.getDocInfo(subData, function(res,msg){ 
					_this.data.docInfo = res
					if (res.freeDoc == 1) {
						sessionStorage.setItem('isfree','2')//是新用户文档并且大于20页
						if(res.ff == 0){
							// ff 为 1 支付过
							_comMeds.countnewLink('v0028', 0, id);
							let data = {
								ids: id
							};
							_score.apiGetComputeInfo(data, function(res,msg){
								// 下载获取积分模块
								_this.data.fileStateOjb = res
								_this.newPeopleDownAlert(params)
							})
						}else{
							_downFile.choiceFormat(id, doctype);
						}
					} else {
						sessionStorage.removeItem('isfree')
						_downFile.choiceFormat(id, doctype);
					}
				},function(res){
					// _comMeds.autoCloseAlert(res.msg);
				})
			} else {
				if ($(this).attr('data-free') == 1&&pagecount <= 20) {
					sessionStorage.setItem('isfree','1')//是新用户文档 小于等于20页
				} else {
					sessionStorage.removeItem('isfree')
				}
				_downFile.choiceFormat(id, doctype);
			}
		})
		// 点击购买积分
        $("body").on('click','.pay-integral',function(){
            $(".common-shadow-bg").remove();
			let payObj = {
                payTab: 1,
                payIndex: 0,
            }
            _allPayBox.payBox(payObj)
        })

		// 点击下载pdf转换文件
		$("body").on('click','.down-pdf',function(){
			let id = $(this).parent("p").data("id");
			let type = $(this).parent("p").data("type");
            _this.data.typeId = type
			_this.deletePdfConverterFile(id, type);
		})

		// 点击取消pdf转换文件 
		$("body").on('click','.cancel-pdf',function(){
			let id = $(this).parent("p").data("id");
			let index = $(this).parent("p").data("index");
			_this.cancelPdf(id,index);
		})

		// 点击删除
		$("body").on('click','.del-doc',function(){
			let id = $(this).parent("p").data("id");
			_this.delDoc(id);
		})
		// 点击校对
		$("body").on('click','.check-doc',function(){
			let id = $(this).parent("p").data("id");
			_this.checkDoc(id);
		})
		// 点击取消翻译
		$("body").on('click','.cancel-doc',function(){
			let id = $(this).parent("p").data("id");
			let index = $(this).parent("p").data("index");
			_this.cancelDoc(id,index);
		})
		// 点击重新翻译
		$("body").on('click','.retran-doc',function(){
			let id = $(this).parent("p").data("id");
			let type = $(this).data("type");
			_this.reTran(id,type);
		})
        // 查看失败积分足够确定付费
		$("body").on('click','.sure-pay-score1',function(e){
			let id = $(this).data("id");
            let type = $(this).data("type")
			_this.reTran(id,type,1);
			e.stopPropagation();
		})
		// 点击回收站恢复文档
		$('body').on('click', '.restore-doc', function(){
			let source = $(this).data('source');
			let id = $(this).parent("p").data("id");
			let data = {
				id: id,
				source: source
			}
            _this.tryRecoverDocs(data);
			// _this.getRecoverDocsInfo(data);
			// } else {
            //     if(source == '-2'){  // 图片恢复
			// 		_this.restoreImg(id);
			// 	}else {  // 文档,网站翻译和格式转换恢复
			// 		_this.getDocExpireDays(id);
			// 	}
			// }
		})

		// 点击彻底删除回收站文件
		$('body').on('click', '.del-doc-recycle', function(){
			let source = $(this).data('source');
			let id = $(this).parent("p").data("id");
			if(source == '-2'){  // 图片彻底删除
                _this.delMyRecycleImg(id);
			} else{
			    _this.delMyRecycle(id);
			}
		})
		// 点击回收站文件来源
		$('body').on('click', 'th.pdf-file-source', function(){
			if(_this.data.node == 2){
                if($('.erji-huishou').css('display') == 'block'){
					$('.erji-huishou').slideUp();
					$('.pdf-file-source i').addClass('icondown').removeClass('iconup');
				} else {
					$('.erji-huishou').slideDown();
					$('.pdf-file-source i').addClass('iconup').removeClass('icondown');
				}
			}
		})
		// 点击我的文件 全部文档
		$('body').on('click', 'th.allFile', function(event){
			// if(_this.data.node == 1){
      //   if($('.erji-myfile').css('display') == 'block'){
			// 		$('.erji-myfile').slideUp();
			// 		$('.allFile i').addClass('icondown').removeClass('iconup');
			// 	} else {
			// 		$('.erji-myfile').slideDown();
			// 		$('.allFile i').addClass('iconup').removeClass('icondown');
			// 	}
			// }
		})

		// 点击批量删除
		$("body").on('click','.my-tran-box .mul-del',function(e){
			let id = _this.data.chooseIds.toString();
			if(_this.data.node == 3){
				_this.delImg(id);
			} else {
                _this.delDoc(id);
			}
		})
		// 点击批量下载
		$("body").on('click','.my-tran-box .mul-down',function(e){
			if ( _this.data.chooseIds.length > 10) {
				_comMeds.autoCloseAlert("批量下载最多10个文件！");
				return false;
			}
			let id = _this.data.chooseIds.toString();
			if(_this.data.node == '7'){
				_this.downloadAllPdf(id);
			} else if(_this.data.node == '3'){
				if(_this.data.chooseStatus.every(function(item){return item == 1})){
					_this.downloadAllImg(id);
				} else {
					_comMeds.autoCloseAlert("翻译失败的图片无法下载，请重新选择");
				}
			}else {
                // _this.downMulDoc(id,300);
				_downFile.choiceFormat(id);
			}
		})
		// 切换批量下载选项
		$("body").on('click','.radio-choose',function(e){
			console.log(1111333)
			// 清除lick事件
			$(".singleTransNow").unbind("click");
			let type = $(this).data("type");
			if (_this.data.chooseIds.length > 10) {
				_comMeds.autoCloseAlert("批量下载最多10个文件！");
				return false;
			}
			if(type == '400' && JSON.parse(localStorage.getItem('userInfo')).memberStatus.memberType.memberType != 'month'){
				return false;
			}
			// if ($(this).parent('.r-c-box').hasClass("active")) {
			// 	return false;
			// }else{
                let id
                if(_this.data.chooseIds.length) {
                    id = _this.data.chooseIds.toString();
                }else {
                    id = _this.data.chooseId
                }
				$(".radio-choose").parent('.r-c-box').removeClass("active");
				$(".mul-down-choose").removeClass("active");
				$(this).parent('.r-c-box').addClass("active");
				_this.downMulDoc(id,type,'',1);
			// }
		})

		// 点击下载(免费)
		$("body").on('click','.btn_isFree',function(e){
		    let type = $(".r-c-box.active").find(".radio-choose").data("type");
            console.log(type)
            // 文件总个数
            let filesNum = $(this).data("filesnum");
            let id
            if(filesNum == 1) {
                id = _this.data.chooseId
            }else {
                id = _this.data.chooseIds.toString();
            }
            if(filesNum == 1) {//单文件下载
                _this.downLoad(id,type,1)
            }else {
                _this.downloadAllTrans(id,type,1);
            }
		    
		    e.preventDefault();
		    e.stopPropagation();
		})

		// 回收站点击批量删除
		$("body").on('click','.del-box .mul-del',function(e){
			let id = _this.data.chooseIds.toString();
            _this.delMyRecycle(id);
		})

		// 点击翻译列表中的详情
		$("body").on('click','.tran-detail',function(e){
		    let id = $(this).parents("p").data("id");

		    if (!$(".pro-detail-box").is(":visible")) {
		    	// 未展开详情
		    	_this.data.watchDetailId = id;
		        $(this).find(".tran-detail-text").text("收起");
		        $(this).find(".tran-detail .iconfont").removeClass("icondown").addClass("iconup");

		        var is_over_bottom = $("body").height() - e.pageY;
		        if (is_over_bottom >=400) {
		            var x_pos = e.pageX - 400;
		            var y_pos = e.pageY + 20;
		        }else{
		            var x_pos = e.pageX - 400;
		            var y_pos = e.pageY - 380;
		        }

		        var str = '<div class="pro-detail-box detail-box-'+id+'" style="display:block;left:'+x_pos+'px;top:'+y_pos+'px;">'+
		                '<div class="devide-line"></div>'+
		                '<div class="left-wrap">'+
		                '<div class="left-wrap-scroll">'+
		                '</div>'+
		                '</div>'+
		                '<div class="right-wrap">'+
		                '<h3>本文档共计<span class="page">-</span>页</h3>'+
		                '<p class="pro-text pro-text1">翻译完成</p>'+
		                '<div class="line-box">'+
		                '<div class="line-bar">'+
		                '<div class="line-con line-con1"></div>'+
		                '</div>'+
		                '<span class="percent percent1"></span>'+
		                '</div>'+
		                '<p class="pro-text pro-text2">正在翻译</p>'+
		                '<div class="line-box">'+
		                '<div class="line-bar">'+
		                '<div class="line-con line-con2"></div>'+
		                '</div>'+
		                '<span class="percent percent2"></span>'+
		                '</div>'+
		                '<p class="pro-text pro-text3">异常</p>'+
		                '<div class="line-box">'+
		                '<div class="line-bar">'+
		                '<div class="line-con line-con3"></div>'+
		                '</div>'+
		                '<span class="percent percent3"></span>'+
		                '</div>'+
		                '<p class="tip">（注：一个正方形代表1页文档）</p>'+
		                '</div>'+
		                '</div>';
		        $("body").append(str);

		        _this.setTranProgress(id);
		    }else{
		    	if ($(".pro-detail-box").is(":visible")) {
		    		$(".status-"+_this.data.watchDetailId+" .tran-detail-text").text("详情");
		        	$(".status-"+_this.data.watchDetailId+" .tran-detail .iconfont").removeClass("iconup").addClass("icondown");
		        	$(".detail-box-"+_this.data.watchDetailId+"").remove();
		    	}else{
		    		$(this).find(".tran-detail-text").text("详情");
		    		$(this).find(".tran-detail .iconfont").removeClass("iconup").addClass("icondown");
		    		$(".detail-box-"+id+"").remove();
		    	}
		    }
		})

		// 点击具体某一方块
		var timer2 = null;
		$("body").on('click','.left-wrap .square',function(e){
		    // var which_page = $(this).index()+1;
		    var which_page = $(this).data("current");
		    var status = $(this).data("status");
		    var msg = $(this).data("msg");
		    var status_str = '';

		    if (!msg) {
		        switch(status){
		            case 1:
		                msg = '翻译完成';
		                break;
		            case 0:
		                msg = '正在翻译';
		                break;
		            default:
		                msg = '翻译异常';
		                break;
		        }
		    }
		    
		    clearTimeout(timer2);

		    $(".pro-tip").remove();
		    var main_box_t = $(".pro-detail-box").offset().top;
		    var tip_t = $(this).offset().top - main_box_t - 22;
		    var tip_str = '<div class="pro-tip" style="left:'+(this.offsetLeft-42)+'px;top:'+tip_t+'px;">第'+which_page+'页<br/>'+msg+'</div>';

		    $(".left-wrap").append(tip_str);
		    timer2 = setTimeout(function(){
		        $(".pro-tip").remove();
		    },1500);
		})

		// 点击搜索
		$(".search-icon").click(function(){
			_this.searchRecode();
		})
		// 回车搜索
		$(".search-box input").keydown(function (e) {
		    if (e.keyCode == "13" || e.which == 13) {
		        _this.searchRecode();
		    } else {
		        return;
		    }
		});

		// 点击input框
		$("body").on("change",'.check-item input',function(e){
			let id = $(this).data("id");
			let is_choose = $.inArray(id,_this.data.chooseIds);
			if (is_choose == '-1') {
				_this.data.chooseIds.push(id);
				if(_this.data.node == 2){
					let choose_source = $(this).data("source");
					_this.data.chooseSource.push(choose_source);
				}
				if(_this.data.node == 3){
					let choose_status = $(this).data("status");
					_this.data.chooseStatus.push(choose_status);
				}	
			}else{
				_this.data.chooseIds.splice(is_choose, 1);
				if(_this.data.node == 2){
					_this.data.chooseSource.splice(is_choose, 1);
				}
				if(_this.data.node == 3){
					_this.data.chooseStatus.splice(is_choose, 1);
				}
			}
			_this.mulOperate(_this.data.chooseIds);
		})

		// 点击加速
		$("body").on('click',".speed-start",function(){
		    if($(this).hasClass("active")){
		        return false;
		    }

		    let tid = $(this).parents("p").data("id");
		    let page = $(this).data("page");
		    let subData = {
		        tid:tid
		    };

		    _tran.getSpeedDocScore(subData,function(res){
		        let str = '<div style="padding:20px 0;">加速翻译将消耗'
		            + res.score
		            + '积分，立即进入加速翻译通道<br/>积分将在翻译成功后扣除。</div>'
		            + '<div class="btn-box">';

		        _comMeds.zgAlert({
		            title:'提示',
		            content:str,
		            width:'440px',
		            yesText:'确定',
		            noText:'取消',
		            yesFn:function(e){
		                
		                _tran.speedDoc(subData,function(res){
		                    $(".speed-start").addClass("active").html('<i class="i1"></i><i class="i2"></i>加速中');

		                    $(".common-shadow-bg").remove();
		                },function(res){
		                	$(".common-shadow-bg").remove();
		                    _comMeds.autoCloseAlert(res.msg);
		                })
		            },
		            noFn:function(e){
		                $(".common-shadow-bg").remove();
		            },
		            closeFn:function(e){
		                $(".common-shadow-bg").remove();
		            }
		        });
		    },function(res){
		        _comMeds.autoCloseAlert(res.msg);
		    })
		})

		// 点击下载图片
		$("body").on('click','.down-img',function(e){
			let id = $(this).parent("p").data("id");
			let downloadType = 2;

			let down_url = _comMeds.getServerUrl('scanPen/image/imageDownload');

			let form = $("<form style='display:none;' target='' method='post' action="+down_url+">");
			let input_str = '<input type="hidden" name="taskId" value="'+id+'" />'
						+'<input type="hidden" name="downloadType" value="'+downloadType+'" />'
						+'<input type="hidden" name="deviceType" value="web" />'
						+'<input type="hidden" name="deviceId" value="'+_comMeds.getDeviceId()+'" />';

			$("body").append(form);
			form.append(input_str);
			form.submit();
		})
		// 点击删除图片
		$("body").on("click",'.del-tran-img',function(e){
			let id = $(this).parent("p").data("id");
			_this.delImg(id);
		})
		// 点击助力
		$("body").on("click",".zhuli-text",function(e){
			let id = $(this).parents().data("id");
			let key = $(this).data("key");
			_tranCommon.showInviteCode(key);
		})

		// 点击勾选过期文档
		$(".is-check-guoqi-p").click(function(e){
			let child = $(this).children('.is-check-guoqi');
			let is_choose = child.hasClass("iconxuanzhong1");
			let type2;
			if(_this.data.node == '2') {
                type2 = $(".erji-huishou div.active").data("type");
			}
			if (is_choose) {
				// 取消选中
				child.removeClass("iconxuanzhong1").addClass("iconoval");
				$('.maintable').DataTable().destroy();
				if(child.hasClass('is-check-system-guoqi')){
					_this.data.isChooseSystemExprice = '';
					_this.getMyRecycleList(type2);
				} else {
					_this.data.isChooseExprice = 0;
					if(_this.data.node == '3'){ // 图片翻译
                       _this.getImgTranList(3);
					} else if(_this.data.node == '7'){ // 格式转换
                       _this.getPdfList();
					} else {
						_this.getMyTranslate(1);
					}
				}
			}else{
				// 选中
				child.removeClass("iconoval").addClass("iconxuanzhong1");
				$('.maintable').DataTable().destroy();
				if(child.hasClass('is-check-system-guoqi')){
					_this.data.isChooseSystemExprice = 1;
					_this.getMyRecycleList(type2);
				} else {
					_this.data.isChooseExprice = 1;
					if(_this.data.node == '7'){ // 格式转换
						_this.getPdfList(11);
					 } else {
						_this.getMyTranslate(11);
					 }
				}
			}
		})

		$("body").on('click', function(e){
			let div_top = $(".pdf-file-source");
      if (!div_top.is(e.target) && div_top.has(e.target).length === 0) {
				$(".erji-huishou").hide();
				$('.pdf-file-source i').addClass('icondown').removeClass('iconup');
      }

			// let div_allFile = $(".allFile");
      // if (!div_allFile.is(e.target) && div_allFile.has(e.target).length === 0) {
			// 	// $(".erji-myfile").hide();
			// 	$('.allFile i').addClass('icondown').removeClass('iconup');
      // }

      e.stopPropagation();
		})

		/**
		 * 回收站批量恢复
		 */
        $('body').on('click', '.mul-restore', function(){
			// _this.getRecoverDocsInfo();
			_this.tryRecoverDocs();
		})
	
		$('body').on('input propertychange', '.add-restore-day-input .add-input', function(e) {
			$(this).val($(this).val().replace(/[^\d]/g, ''));

			if($(this).val().length > 3){
				$(this).val($(this).val().slice(0,3))
			}
 
			if($(this).hasClass('overdue-input')){
                if($(this).val() > 1){
					$(this).siblings('.reduce').addClass('active');
				} else {
					$(this).siblings('.reduce').removeClass('active');
				}
			} else {
                if($(this).val() > 0){
					$(this).siblings('.reduce').addClass('active');
				} else {
					$(this).siblings('.reduce').removeClass('active');
				}
			}
			setTimeout(() => {
				var totalBean = 0;
				$('.add-restore-day-input .add-input').each(function(){
					totalBean += Number($(this).val());
				})
				if(totalBean > _this.data.userCoins){
					$('.sure-restoreDoc').addClass('grey');
					$('.add-restore-day-input .add').removeClass('active');
					$('.usable-bean').addClass('red');
				} else if(totalBean == _this.data.userCoins){
					$('.add-restore-day-input .add').removeClass('active');
					$('.sure-restoreDoc').removeClass('grey');
					$('.usable-bean').removeClass('red');
				}else {
					$('.sure-restoreDoc').removeClass('grey')
					$('.usable-bean').removeClass('red');
					$('.add-restore-day-input .add-input').each(function(){
                        if($(this).val() == 999){
							$(this).siblings('.add').removeClass('active');
						} else {
							$(this).siblings('.add').addClass('active');
						}
					})
				}
				$('.total-bean').text(totalBean);
			}, 1000)
		})

		$('body').on('blur','.add-restore-day-input .add-input', function(e){
		    let totalBean = $('.total-bean').text();
			if($(this).val() == '') {
				if($(this).hasClass('overdue-input')){
					$(this).val('1');
					totalBean++;
				} else {
					$(this).val('0');
				}
			} else {
				if($(this).hasClass('overdue-input')){
					if($(this).val() < 1){
						$(this).val('1');
						totalBean++;
					} 
				}
			}
			$('.total-bean').text(totalBean);
		} )


		$('body').on('click', '.add-restore-day-input .add', function(){
			if($(this).hasClass('active')){
				let num = $(this).siblings('.add-input').val();
				let totalBean = Number($('.total-bean').text());
				if(num < 999) {
					num++;
					totalBean++;
					$(this).siblings('.add-input').val(num);
					$(this).siblings('.reduce').addClass('active');
					$('.total-bean').text(totalBean);
					if(totalBean >= _this.data.userCoins){
						$('.add-restore-day-input .add').removeClass('active');
					}
					if(num == 999){
						$(this).removeClass('active');
					}
				} else {
					$(this).removeClass('active');
					return false;
				}
			}	
		})
		$('body').on('click', '.add-restore-day-input .reduce', function(){
			if($(this).hasClass('active')){
				let num = $(this).siblings('.add-input').val();
				let totalBean = Number($('.total-bean').text());
				if($(this).siblings('.add-input').hasClass('overdue-input')){
					if(num > 1) {
						num--;
						$(this).siblings('.add-input').val(num);
						if(totalBean > 0) {
							totalBean--;
						}
						if(num == 1) {
							$(this).removeClass('active');
						}
						$('.total-bean').text(totalBean);
					} else {
						$(this).removeClass('active');
						return false;
					}
				} else {
                    if(num > 0) {
						num--;
						$(this).siblings('.add-input').val(num);
						if(totalBean > 0) {
							totalBean--;
						}
						if(num == 0) {
							$(this).removeClass('active');
						}
						$('.total-bean').text(totalBean);
					} else {
						$(this).removeClass('active');
						return false;
					}
				}
				if(totalBean <= _this.data.userCoins){
					$('.add-restore-day-input .add-input').each(function(){
                        if($(this).val() == 999){
							$(this).siblings('.add').removeClass('active');
						} else {
							$(this).siblings('.add').addClass('active');
						}
					})
					$('.sure-restoreDoc').removeClass('grey');
					$('.usable-bean').removeClass('red');
				}
			}	
		})
	},

	//获取url
	getURLcurrent() {
		_comMeds.getUrlParam("historyRecord")
		let current = _comMeds.getUrlParam("historyRecord")
		console.log(current);
		if (current == "2") {
			$('.top-toggle ul li').eq(0).removeClass('active')
			$('.top-toggle ul li').eq(1).addClass('active')
			this.getImgTranList(3)
		}
	},
	// 是否展示单次付费
	isShowSinglePay() {
		let _this = this;
		_vip.isShowSinglePay({}, function(res) {
			_this.data.isShowSingle = res
		},function(res){
			
		})
	},
	// 获取翻译列表
	getMyTranslate: function(node) {
		let _this = this,allText = '';
		let textIndex = $(".erji-myfile div.active").data("type")
		if (textIndex === 3) {
			allText = 'OpenAI翻译'
		} else if (textIndex === 2) {
			allText = '谷歌翻译'
		} else if (textIndex === 1) {
			allText = 'DeepL翻译'
		} else if (textIndex === 0) {
			allText = '通用翻译'
		} else if (textIndex === 4) {
			allText = '医药翻译'
		} else {
			allText = '全部文档'
		}
		let chooseTransTy = _this.data.chooseTransTy
		// console.log(chooseTransTy)
		let lanTypeList = `<div class="erji-myfile">
              <div class="${chooseTransTy === ''?'active':''}" data-type=""><i class="iconfont icondingbuchenggongtishi has-choose"></i>全部文档</div>
              <div class="${chooseTransTy === 0?'active':''}" data-type="0"><i class="iconfont icondingbuchenggongtishi has-choose"></i>通用翻译</div>
              <div class="${chooseTransTy === 1?'active':''}" data-type="1"><i class="iconfont icondingbuchenggongtishi has-choose"></i>DeepL翻译</div>
              <div class="${chooseTransTy === 2?'active':''}" data-type="2"><i class="iconfont icondingbuchenggongtishi has-choose"></i>谷歌翻译</div>
              <div class="${chooseTransTy === 3?'active':''}" data-type="3"><i class="iconfont icondingbuchenggongtishi has-choose"></i>OpenAI翻译</div>
              <div class="${chooseTransTy === 4?'active':''}" data-type="4"><i class="iconfont icondingbuchenggongtishi has-choose"></i>医药翻译</div>
            </div>`
		
        _this.data.sum++
        if(_comMeds.getUrlParam("historyRecord")=="1" && _this.data.sum == '1') {
            $('.top-toggle ul li').eq(0).removeClass('active')
            $('.top-toggle ul li').eq(2).addClass('active')
            _this.getPdfList();
            _this.getDocExpireCount();            
        }else {
            let matchIdCount = 0;
            this.data.chooseIds = [];
            $(".my-tran-box").hide();
            $(".del-box").hide();

            $('.maintable').DataTable({
                autoWidth:false, // 控制Datatables是否自适应宽度
                info: true, // 控制是否显示表格左下角的信息
                lengthChange:false, // 是否允许用户改变表格每页显示的记录数
                lengthMenu:[10], // 显示几项结果
                ordering:false, // 是否允许Datatables开启排序
                serverSide:true, // 是否开启服务器模式
                dom: 't<"table-bottom-box clearfix"i<"select-page"l>p>',
                stateSave: false, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
                searching:true, // 是否允许Datatables开启本地搜索
                columns: [
                    {
                        data: null,
                        title:'<label class="check-box all-check"><input type="checkbox" name="total-check" class="total-check" /></label>',
                        width:'4%',
                        className:'align-left',
                        render: function(data, type, row, meta){
                            let input_item = '';
                            if(row.ff == 0 || row.status != 1) {
                                input_item = '<input type="checkbox" class="no-choose" disabled="disabled" data-id="'+row.id+'" />';
                            }else{
                                if ($.inArray(row.id,_this.data.chooseIds) != -1){
                                    input_item = '<input type="checkbox" checked="true" class="can-choose" data-id="'+row.id+'" />';
                                    matchIdCount++;
                                    if (matchIdCount == 10) {
                                        $(".total-check").prop("checked",true);
                                    }
                                }else{
                                    input_item = '<input type="checkbox" class="can-choose" data-id="'+row.id+'" />';
                                    $(".total-check").prop("checked",false);
                                }
                            }

                            var content = '<label class="check-box check-item">'
                                    +input_item
                                    +'</label>';
                            return content;
                        }
                    },
                    {
                        title:`<div class="lan-box">${allText}<i class='iconfont icondown'></i><i class='iconfont iconup'></i>${lanTypeList}</div>`,
                        data: 'title',
                        width:'25%',
                        className:'align-left img-td allFile',
                        render: function(data, type, row, meta){
                            let file_type = _comMeds.getFileExtendingName(row.docType);
                            let img_url = require("../../../assets/images/tran/translate_list_" + file_type + "@2x.png");
                            let img_src = "<img class = 'file-img' src = "+img_url+">";
                            let file_name = "<p class='file-name'>"+data+"."+row.docType+"</p>";
                            let source_str = '';
                            if (row.source == '-1') {
                                source_str = `<p class="source">来源：网站翻译</p>`;
                            }
                            return img_src + file_name + source_str;
                        }
                    },
                    {
                        title:'页数<div class="question-box"><span class="iconfont iconwenhao page-tip"><span class="message-tip">Word、PDF、PPT按原页数计算；Excel、TXT、HTML、图片、CAD翻译每2000字符为1页</span></span></div>',
                        width:'8%',
                        className:'align-left',
                        data: 'pageCount',
                        render:function(data,type,row,meta){
                            return '<div class="page-num-'+row.id+'">'+data+'页</div>';
                        }
                    },
                    {
                        title:"翻译语言",
                        data: 'fromLanguage',
                        width:'15%',
                        className:'align-left',
                        render: function(data, type, row, meta){
                            let str = '<p>'+row.fromLanguage+'<span class="iconfont iconjiantouyou item-jiantou"></span>'+row.toLanguage+'</p>';
                            let bilingualControl = '<p class="biling">原译文同文档<p>'
                            if(row.bilingualControl){
                                return str + bilingualControl;
                            }
                            return str;
                        }
                    },
                    {
                        title:"状态",
                        width:'15%',
                        className:'align-left',
                        data: 'status',
                        render:function(data,type,row,meta){
                            let tran_icon = '';
                            let tran_text = '';
                            let timeout_str = '';
                            let detail_str = '';

							if (row.status == "0" || row.status == "-12" || row.status == "-10"){
                                // 等待或正在翻译中
                                if (row.rank >= '1') {
                                    // 排队
                                    if(row.docType == 'ofd') {

                                        tran_icon = '<span class="icon-tip icon-ofd-wait"></span>';
                                    }else {
                                        tran_icon = '<span class="icon-tip icon-wait"></span>';
                                    }
                                    tran_text = '<span class="tran-status-text">正在排队，前面还有'+row.rank+'人</span>';
                                }else{
                                    if (row.model >= 119 && row.model < 130 && row.docType == 'pdf') {
                                        if (row.displayUpSpeedStatus != 1 || row.displayUpSpeedStatus != 2) {
                                            detail_str = '<span class="tran-detail"><span class="tran-detail-text">详情</span><span class="iconfont icondown"></span></span>';
                                        }
                                    }
                                    
                                    if(row.docType == 'ofd') {
                                        tran_icon = '<span class="icon-tip icon-ofd-wait"></span>';
                                        tran_text = '<span class="tran-status-text">进行中</span>'+detail_str
                                        +'<span class="translate-status" style="width: ' + row.percent * 1080 / 100 + 'px"></span>';
                                    }else {
                                        tran_icon = '<span class="icon-tip icon-wait"></span>';
                                        tran_text = '<span class="tran-status-text">已翻译'+row.percent+'%</span>'+detail_str
                                        +'<span class="translate-status" style="width: ' + row.percent * 1080 / 100 + 'px"></span>';
                                    }
                                    if (row.percent > 99) {
                                        row.percent = 100;
                                    }

                                }

                                _this.data.table_timer[meta.row] = setInterval(function(){
                                    _this.queryTranslateDoc(row.id,meta.row);
                                }, 2000);
                            }else if (row.status == "1") {
                                // 翻译成功
                                if (row.boostStatus == '1') {
                                    // 表示助力中
                                    tran_icon = '<span class="icon-tip icon-zhuli"></span>';
                                    tran_text = '<span class="tran-status-text zhuli-text" data-key="'+row.boostKey+'">助力中<i class="iconyoujian iconfont"></i></span>';
                                }else{
                                    if (row.pdfDownloadAction == '1' || row.wordDownloadAction == '1') {
                                        tran_icon = '<span class="icon-tip icon-down"></span>';
                                        tran_text = '<span class="tran-status-text">已下载</span>';
                                    }else{
                                        tran_icon = '<span class="icon-tip icon-finish"></span>';
                                        tran_text = '<span class="tran-status-text">已完成</span>';
                                    }
                                }
                            }else if(row.status == "3"){
                                // 校对中
                                if (row.subNumber == "1") {
                                    // 查询
                                    /*_this.data.table_timer = setInterval(function(){
                                        _this.queryTranslateDoc(row.id);
                                    }, 2000);	*/						
                                }
                                tran_icon = '<span class="icon-tip icon-wait"></span>';
                                tran_text = '<span class="tran-status-text">校对中</span>';
                            }else if(row.status == "-11"){
                                // 已取消
                                tran_icon = '<span class="icon-tip icon-cancel"></span>';
                                tran_text = '<span class="tran-status-text">已取消</span>';
                            }else if(row.status == "-3"){
                                // 人工处理
                                tran_icon = '<span class="icon-tip icon-fail"></span>';
                                tran_text = '<span class="tran-status-text">翻译失败</span>'
                                        +'<span class="iconfont iconwenhao fail-tip-icon">'
                                        +'<span class="fail-tip-text">'+row.msg+'</span>'
                                        +'</span>';
                                if (node == '1') {
                                    _this.data.table_timer[meta.row] = setInterval(function(){
                                        _this.queryTranslateDoc(row.id,meta.row);
                                    }, 2000);
                                }
                            }else if(row.status == "-13"){
                                // 未读取到需要翻译的内容
                                tran_icon = '<span class="icon-tip icon-fail"></span>';
                                tran_text = '<span class="tran-status-text">翻译失败</span>'
                                        +'<span class="iconfont iconwenhao fail-tip-icon">'
                                        +'<span class="fail-tip-text">'+row.msg+'</span>'
                                        +'</span>';
                            }else{
                                tran_icon = '<span class="icon-tip icon-fail"></span>';
                                tran_text = '<span class="tran-status-text">翻译失败</span>'
                                        +'<span class="iconfont iconwenhao fail-tip-icon">'
                                        +'<span class="fail-tip-text">'+row.msg+'</span>'
                                        +'</span>';
                            }

                            let status = '<p data-id="'+row.id+'" class="status-'+row.id+'">'+tran_icon+tran_text+'</p>';
                            let create_time = '<p class="create-time">'+row.createTime+'</p>';

                            // 显示剩余天数
                            // if (node === '1') {
                            //     if (row.remainDays > 0 && row.remainDays <= 7) {
                            //         timeout_str = '<div class="remain-time time-'+row.id+'">剩余时长：'+row.remainDays+'天</div>';
                            //     }
                            // }
                            let a = JSON.parse(localStorage.getItem("userInfo")).memberStatus.memberType.memberType
                            if(a != "month") {
                                if (row.remainStorageDays >= 0 && row.remainStorageDays <= 7) {
                                    timeout_str = '<div class="remain-time time-'+row.id+'">剩余时长：'+row.remainStorageDays+'天</div>';
                                }
                            }

                            return status + create_time + timeout_str;
                        }
                    },
                    {
                        title:"操作",
                        width:'13%',
                        className:'align-left',
                        data: 'info',
                        render:function(data,type,row,meta){
                            let operate_item = '';
                            if (node == '1' || node == '11') {
                                let del, red_doc, down_doc;
                                if(node == '11' && _this.data.node == '3'){
                                    del = 'del-tran-img';
                                    red_doc = 'read-img';
                                    down_doc = 'down-img';
                                } else {
                                    del = 'del-doc';
                                    red_doc = 'reads-doc';
                                    down_doc = 'down-doc';
                                }
                                if (row.status == 1) {
                                    // if(row.ff == 0) {
                                    //     operate_item = '<span class="paySuccess" style="color: #96A4BB;"><em style="color: #1062F3;">支付</em>后可阅读</span>'
                                    // }else 
                                    // {
                                    //     // 翻译成功
                                    //     if (row.pdfDownloadAction == '1' || row.wordDownloadAction == '1'){
                                    //         operate_item = '<span class="'+red_doc+'" style="top:-6px;">阅读</span>'
                                    //         +'<span class="'+down_doc+'">再次<br/>下载</span>'
                                    //         +'<span class="'+del+'" style="top:-6px;">删除</span>';
                                    //     }else{
                                    //         operate_item = '<span class="'+red_doc+'">阅读</span>'
                                    //         +'<span class="'+down_doc+'">下载</span>'
                                    //         +'<span class="'+del+'">删除</span>';
                                    //     }                                        
                                    // }
                                    // 翻译成功
                                    if (row.pdfDownloadAction == '1' || row.wordDownloadAction == '1'){
                                        operate_item = '<span class="'+red_doc+'" style="top:-6px;">阅读</span>'
                                        +'<span data-free='+ row.freeDoc +' class="'+down_doc+'">再次<br/>下载</span>'
                                        +'<span class="'+del+'" style="top:-6px;">删除</span>';
                                    }else{
                                        operate_item = '<span class="'+red_doc+'">阅读</span>'
                                        +'<span data-free='+ row.freeDoc +' class="'+down_doc+'">下载</span>'
                                        +'<span class="'+del+'">删除</span>';
                                    } 

                                }else if(row.status == '0'){
                                    // 正在翻译中
                                    if(_this.data.node != '3'){
                                        if (row.displayUpSpeedStatus == 1) {
                                            operate_item = "<span class='speed speed-up speed-start' data-page="+row.pageCount+"><i class='i1'></i><i class='i2'></i>加速</span>";
                                        }else if(row.displayUpSpeedStatus == 2){
                                            operate_item = "<span class='speed speed-up active'><i class='i1'></i><i class='i2'></i>加速中</span>";
                                        }else{
                                            operate_item = '<span class="cancel-doc">取消</span>';
																						// 边译边读
																						if(row.goingRead == 1) {
																							operate_item = '<span class="reads-doc">阅读</span>';
																						}
                                        }
                                    } else {
                                        operate_item = '';
                                    }
                                }else if(row.status == 3){
                                    // 校对
                                    if (row.subNumber == 1) {
                                        operate_item = '<span class="check-doc">校对</span>';
                                    }
                                }else if(row.status == '-11'){
                                    operate_item = '<span class="'+del+'">删除</span>';
                                }else if(row.status == '-3'){
                                    operate_item = '<span class="retran-doc" data-type='+row.docType+'>重新翻译</span><span class="'+del+'">删除</span>';
                                }else{
                                    operate_item = '<span class="'+del+'">删除</span>';
                                } 

                            }else{
                                operate_item = '<span class="restore-doc">恢复</span><span class="del-doc-recycle">删除</span>';
                            }

                            let operate_str = '<p class="operate-box table-item-'+row.id+'" data-id="'+row.id+'" data-type="'+row.docType+'" data-index="'+meta.row+'" data-transType="'+row.transType+'" data-pagecount="'+row.pageCount+'" data-bilingualControl="'+row.bilingualControl+'">'
                                    +operate_item
                                    +'</p>';
                            return operate_str;
                        }
                    }
                ],
                ajax: function (data, callback, settings) {
                    //封装相应的请求参数，这里获取页大小和当前页码
                    var pagesize = data.length;//页面显示记录条数，在页面显示每页显示多少项的时候,页大小
                    var start = data.start;//开始的记录序号
                    var page = (data.start) / data.length + 1;//当前页码
                    var subData = {
                        page:page,
                        title:$(".search-input").val(),
												transType: _this.data.chooseTransTy, // 空：全部（默认），0：通用，1：deepl  4医药
                    };
                    matchIdCount = 0;

                    // 翻页清除前一页的定时器
                    for(var i = 0; i <= _this.data.table_timer.length; i++){
                        clearInterval(_this.data.table_timer[i]);   
                    }
                    if ($(".pro-detail-box")) {
                        $(".pro-detail-box").remove();
                    }
                    if (node == '1') {
                        _tran.getMyTranslate(subData, function(res,msg){
                            let returnData = {};
                            if (res.total === 0) {
                                $(".table-bottom-box").hide();
                                $(".empty-box").show();
                            }else{
                                $(".empty-box").hide();
                            }

                            returnData.recordsTotal = res.total;
                            returnData.recordsFiltered = res.total;
                            returnData.data = res.list;
                            callback(returnData);
                        },function(res){
                            _comMeds.autoCloseAlert(res.msg);
                        })
                    }else if(node == '2'){
                        _tran.getMyRecycle(subData, function(res,msg){
                            let returnData = {};
                            if (res.total === 0) {
                                $(".table-bottom-box").hide();
                                $(".empty-box").show();
                            }else{
                                $(".empty-box").hide();
                            }
                            returnData.recordsTotal = res.total;
                            returnData.recordsFiltered = res.total;
                            returnData.data = res.list;
                            callback(returnData);
                        },function(res){
                            _comMeds.autoCloseAlert(res.msg);
                        })
                    }else if(node == '11'){
                        let docSource;
                        if(_this.data.node == '1'){
                            docSource = 0
                        } else if(_this.data.node == '3'){
                            docSource = -2
                        } else if(_this.data.node == '7'){
                            docSource = -3
                        }
                        let subData = {
                            page:page,
                            title:$(".search-input").val(),
                            rows:10,
                            docSource:docSource
                        };
                        _tran.getExpireDocList(subData, function(res,msg){
                            let returnData = {};
                            if (res.total === 0) {
                                $(".table-bottom-box").hide();
                                $(".empty-box").show();
                            }else{
                                $(".empty-box").hide();
                            }
                            returnData.recordsTotal = res.total;
                            returnData.recordsFiltered = res.total;
                            returnData.data = res.list;
                            callback(returnData);
                        },function(res){
                            _comMeds.autoCloseAlert(res.msg);
                        })
                    }
                },
                "fnRowCallback": function( nRow, aData, iDisplayIndex, iDisplayIndexFull ) { 
                	//改行满足的条件
                    console.log(aData.ff)
                    if(aData.ff == 0 || aData.status != 1) {
                        $(nRow).css("opacity", "0.7");
                    }

                }
            }); 
            $('')           
        }

	},
	// 获取图片翻译列表
	getImgTranList(node) {
		console.log(node);
		let _this = this;
		let matchIdCount = 0;
		this.data.chooseIds = [];
		$(".my-tran-box").hide();
		$(".del-box").hide();
		$('.maintable').DataTable({
			autoWidth:false, // 控制Datatables是否自适应宽度
			info: true, // 控制是否显示表格左下角的信息
			lengthChange:false, // 是否允许用户改变表格每页显示的记录数
			lengthMenu:[10], // 显示几项结果
			ordering:false, // 是否允许Datatables开启排序
			serverSide:true, // 是否开启服务器模式
			dom: 't<"table-bottom-box clearfix"i<"select-page"l>p>',
			stateSave: false, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
			searching:true, // 是否允许Datatables开启本地搜索
			columns: [
				{
					data: null,
					title:'<label class="check-box all-check"><input type="checkbox" name="total-check" class="total-check" /></label>',
					width:'4%',
					className:'align-left',
					render: function(data, type, row, meta){
						let input_item = '';
						if (row.status == '0') {
							input_item = '<input type="checkbox" class="no-choose" disabled="disabled" data-id="'+row.id+'" data-status="'+row.status+'" />';
						}else{
							if ($.inArray(row.id,_this.data.chooseIds) != -1){
								input_item = '<input type="checkbox" checked="true" class="can-choose" data-id="'+row.id+'" data-status="'+row.status+'" />';
								matchIdCount++;
								if (matchIdCount == 10) {
									$(".total-check").prop("checked",true);
								}
							}else{
								input_item = '<input type="checkbox" class="can-choose" data-id="'+row.id+'" data-status="'+row.status+'" />';
								$(".total-check").prop("checked",false);
							}
						}

						var content = '<label class="check-box check-item">'
								+input_item
								+'</label>';
						return content;
					}
				},
				{
					title:"文档名",
					data: 'fileName',
					width:'25%',
					className:'align-left img-td',
					render: function(data, type, row, meta){
						let file_type = _comMeds.getFileExtendingName(row.fileType);
						let img_url = require("../../../assets/images/tran/translate_list_" + file_type + "@2x.png");
						let img_src = "<img class = 'file-img' src = "+img_url+">";
						let file_name = "<p class='file-name'>"+data+"."+row.fileType+"</p>";
						return img_src + file_name;
					}
				},
				{
					title:'页数<div class="question-box"><span class="iconfont iconwenhao page-tip"><span class="message-tip">Word、PDF、PPT按原页数计算；Excel、TXT、HTML、图片、CAD翻译每2000字符为1页</span></span></div>',
					width:'8%',
					className:'align-left',
					data: 'page',
					render:function(data,type,row,meta){
						return '<div class="page-num-'+row.id+'">'+data+'页</div>';
					}
				},
				{
					title:"翻译语言",
					data: 'fromLanguage',
					width:'15%',
					className:'align-left',
					render: function(data, type, row, meta){
						let str = '<p>'+row.fromLanguage+'<span class="iconfont iconjiantouyou item-jiantou"></span>'+row.toLanguage+'</p>';
						let bilingualControl = '<p>原译文同文档<p>'
						if(row.bilingualControl){
							return str + bilingualControl;
						}
						return str;
					}
				},
				{
					title:"状态",
					width:'15%',
					className:'align-left',
					data: 'status',
					render:function(data,type,row,meta){
						let tran_icon = '';
						let tran_text = '';
						let timeout_str = '';
						let detail_str = '';

						if (row.status == "0"){
							// 等待或正在翻译中
							if (row.rank >= '1') {
								// 排队
								tran_icon = '<span class="icon-tip icon-wait"></span>';
								tran_text = '<span class="tran-status-text">正在排队，前面还有'+row.rank+'人</span>';
							}else{
								tran_icon = '<span class="icon-tip icon-wait"></span>';
								if (row.percent > 99) {
									row.percent = 100;
								}
								tran_text = '<span class="tran-status-text">已翻译'+row.percent+'%</span>'+detail_str
										+'<span class="translate-status" style="width: ' + row.percent * 1080 / 100 + 'px"></span>';
							}

							_this.data.table_timer[meta.row] = setInterval(function(){
								_this.queryTranslateImg(row.id,meta.row);
							}, 2000);
						}else if (row.status == "1") {
							// 翻译成功
							if (row.pdfDownloadAction == '1' || row.wordDownloadAction == '1') {
								tran_icon = '<span class="icon-tip icon-down"></span>';
								tran_text = '<span class="tran-status-text">已下载</span>';
							}else{
								tran_icon = '<span class="icon-tip icon-finish"></span>';
								tran_text = '<span class="tran-status-text">已完成</span>';
							}
						}else if(row.status == '2'){
                            tran_icon = '<span class="icon-tip icon-fail"></span>';
							tran_text = '<span class="tran-status-text">原图(未翻译)</span>';
						}else{
							tran_icon = '<span class="icon-tip icon-fail"></span>';
							let reson;
							if(row.errorMsg){
								reson = row.errorMsg
							} else {
								reson = '翻译失败';
							}
							tran_text = '<span class="tran-status-text">翻译失败</span>'
									+'<span class="iconfont iconwenhao fail-tip-icon">'
									+'<span class="fail-tip-text">'+reson+'</span>'
									+'</span>';
						}

						let status = '<p data-id="'+row.id+'" class="status-'+row.id+'">'+tran_icon+tran_text+'</p>';
						let create_time = '<p class="create-time">'+_comMeds.formatTime(row.createTime)+'</p>';

						return status + create_time + timeout_str;
					}
				},
				{
					title:"操作",
					width:'13%',
					className:'align-left',
					data: 'info',
					render:function(data,type,row,meta){
						let operate_item = '';
						
						if (node == '3') {
							if (row.status == 1) {
								// 翻译成功
								if (row.pdfDownloadAction == '1' || row.wordDownloadAction == '1'){
									operate_item = '<span class="read-img" style="top:-6px;">阅读</span>'
									+'<span class="down-img">再次<br/>下载</span>'
									+'<span class="del-tran-img" style="top:-6px;">删除</span>';
								}else{
									operate_item = '<span class="read-img">阅读</span>'
									+'<span class="down-img">下载</span>'
									+'<span class="del-tran-img">删除</span>';
								}
							}else if(row.status == '0'){
								operate_item = '';
							}else if(row.status == 3){
								// 校对
								if (row.subNumber == 1) {
									operate_item = '<span class="check-doc">校对</span>';
								}
							}else if(row.status == '-11'){
								operate_item = '<span class="del-tran-img">删除</span>';
							}else if(row.status == '-3'){
								operate_item = '<span class="retran-doc" data-type='+row.docType+'>重新翻译</span><span class="del-tran-img">删除</span>';
							}else{
								operate_item = '<span class="del-tran-img">删除</span>';
							}
						}else{
							operate_item = '<span class="restore-img">恢复</span><span class="del-img-recycle">删除</span>';
						}

						let operate_str = '<p class="operate-box table-item-'+row.id+'" data-id="'+row.id+'" data-type="'+row.docType+'" data-index="'+meta.row+'" data-pagecount="'+row.pageCount+'" data-bilingualControl="'+row.bilingualControl+'">'
								+operate_item
								+'</p>';
						return operate_str;
					}
				}
			],
			ajax: function (data, callback, settings) {
				//封装相应的请求参数，这里获取页大小和当前页码
				var pagesize = data.length;//页面显示记录条数，在页面显示每页显示多少项的时候,页大小
				var start = data.start;//开始的记录序号
				var page = (data.start) / data.length + 1;//当前页码
				var subData = {
					page:page,
					title:$(".search-input").val(),
					rows:10
				};
				matchIdCount = 0;

				// 翻页清除前一页的定时器
				for(var i = 0; i <= _this.data.table_timer.length; i++){
				    clearInterval(_this.data.table_timer[i]);   
				}
				if ($(".pro-detail-box")) {
					$(".pro-detail-box").remove();
				}

				if (node == '3') {
					_tran.imageList(subData, function(res,msg){
						let returnData = {};
						if (res.total === 0) {
							$(".table-bottom-box").hide();
							$(".empty-box").show();
						}else{
							$(".empty-box").hide();
						}
						returnData.recordsTotal = res.total;
						returnData.recordsFiltered = res.total;
						returnData.data = res.scanFileList;
						callback(returnData);
					},function(res){
						_comMeds.autoCloseAlert(res.msg);
					})
				}else if(node == '4'){
					_tran.getImageRecycleList(subData, function(res,msg){
						let returnData = {};
						if (res.total === 0) {
							$(".table-bottom-box").hide();
							$(".empty-box").show();
						}else{
							$(".empty-box").hide();
						}
						returnData.recordsTotal = res.total;
						returnData.recordsFiltered = res.total;
						returnData.data = res.recycleList;
						callback(returnData);
					},function(res){
						_comMeds.autoCloseAlert(res.msg);
					})
				}
			},
		});
	},
	// 查询某个文件翻译进度
	queryTranslateDoc : function(id,index){
		let _this = this;
		let subData = {
			tid:id
		};

		_tran.queryDocProgress(subData, function(res,msg){
			if (res.status == "0" || res.status == "-12" || res.status == "-10") {
				// 等待或正在翻译中
				if (res.rank >= '1') {
					// 排队
					$(".status-"+res.id+" .tran-status-text").text('正在排队，前面还有'+res.rank+'人');
				}else{
					res.percent = _comMeds.fomatFloat(res.percent,2)
					if (res.model >= 119 && res.model < 130 && res.docType == 'pdf') {
						if ($(".detail-box-"+res.id+"").length > 0) {
							_this.setTranProgress(_this.data.watchDetailId);
						}
					}else{
						$(".status-"+res.id+" .tran-detail").hide();
						$(".detail-box-"+res.id+"").remove();
					}
					
					$(".table-box tbody .page-num-"+res.id+"").text(res.pageCount+'页');
					$(".status-"+res.id+"").find(".icon-fail").removeClass("icon-fail").addClass("icon-wait");
                    if(res.docType == 'ofd') {

                        $(".status-"+res.id+" .tran-status-text").text("进行中");
                    }else {
                        $(".status-"+res.id+" .tran-status-text").text("已翻译"+res.percent+'%');
                    }
					$(".status-"+res.id+" .translate-status").css({
						width: res.percent * 1080 / 100 + 'px'
					})

					if (res.displayUpSpeedStatus == 1) {
						// 显示加速
						if ($(".table-item-"+res.id+" .speed-start").length ==0) {
							$(".table-item-"+res.id+"").html("<div class='speed speed-up speed-start' data-page="+res.pageCount+"><i class='i1'></i><i class='i2'></i>加速</div>");
						}
					}else if(res.displayUpSpeedStatus == 2){
						// 显示加速中
						if ($(".table-item-"+res.id+" .speed-up.active").length ==0) {
							$(".table-item-"+res.id+"").html("<div class='speed speed-up active' data-page="+res.pageCount+"><i class='i1'></i><i class='i2'></i>加速中</div>");
						}
					}else{
						$(".table-item-"+res.id+"").html('<span class="cancel-doc">取消</span>');
						// 边译边读
						if(res.goingRead == 1) {
							$(".table-item-"+res.id+"").html('<span class="reads-doc">阅读</span>');
						}
					}
				}
			}else if(res.status == '1'){
                console.log('id=' + res.id)
        //         $(".status-"+res.id+"").parents("tr").css("opacity", "1")
				// $(".status-"+res.id+" .icon-tip").removeClass("icon-wait").addClass("icon-finish");
				// $(".status-"+res.id+" .tran-status-text").text("已完成");
				
				// let success_operate = '<span class="reads-doc">阅读</span><span data-free='+ res.freeDoc +' class="down-doc">下载</span><span class="del-doc">删除</span>';
				// $(".table-item-"+res.id+"").html(success_operate);
				// $(".status-"+res.id+" .translate-status").remove();
				// $(".status-"+res.id+"").parents("tr").find("td .no-choose").removeAttr("disabled").removeClass("no-choose").addClass("can-choose");

				clearInterval(_this.data.table_timer[index]);
				$('.maintable').DataTable().destroy();
				_this.getMyTranslate(1)
			}else if(res.status == '3'){
				$(".status-"+res.id+" .tran-status-text").text("校对中");
				$(".table-item-"+res.id+"").html('<span class="check-doc">校对</span>');

				$(".status-"+res.id+" .translate-status").remove();
				clearInterval(_this.data.table_timer[index]);
			}else{
				let err_question = '<span class="iconfont iconwenhao fail-tip-icon">'
						+'<span class="fail-tip-text">'+res.msg+'</span>'
						+'</span>';		

				$(".status-"+res.id+" .icon-tip").removeClass("icon-wait").addClass("icon-fail");
				$(".status-"+res.id+" .tran-status-text").text("翻译失败");
				$(".status-"+res.id+" .translate-status").remove();
				if ($(".status-"+res.id+" .fail-tip-icon").length == 0) {
					$(".status-"+res.id+"").append(err_question);
				}
				
				if (res.status == "-12" || res.status == "-10") {
					let operate_item = '<span class="del-doc">删除</span>';
					$(".table-item-"+res.id+"").html(operate_item);
					return;
				}else if(res.status == "-3"){
					return;
				}else{
					let operate_item = '<span class="retran-doc" data-type='+res.docType+'>重新翻译</span><span class="del-doc">删除</span>';
					$(".table-item-"+res.id+"").html(operate_item);
					clearInterval(_this.data.table_timer[index]);
				}
			}
		},function(res){
			// _comMeds.autoCloseAlert(res.msg);
			// clearInterval(_this.data.table_timer);
		})
	},
	// 查询pdf某个文件翻译进度
	queryTranslatePdf : function(id,index){
		let _this = this;
		let subData = {
			tid:id
		};

		_pdf.queryDocProgress(subData, function(res,msg){
			if (res.status == '0') {
				// 等待或正在翻译中
				if (res.rank >= '1') {
					// 排队
					$(".status-"+res.id+" .tran-status-text").text('正在排队，前面还有'+res.rank+'人');
				}else{
					res.percent = _comMeds.fomatFloat(res.percent,2)
					if (res.model >= 119 && res.model < 130 && res.docType == 'pdf') {
						if ($(".detail-box-"+res.id+"").length > 0) {
							// _this.setTranProgress(_this.data.watchDetailId);
						}
					}else{
						$(".status-"+res.id+" .tran-detail").hide();
						$(".detail-box-"+res.id+"").remove();
					}
					
					$(".table-box tbody .page-num-"+res.id+"").text(res.pageCount+'页');
					$(".status-"+res.id+"").find(".icon-fail").removeClass("icon-fail").addClass("icon-wait");
					$(".status-"+res.id+" .tran-status-text").text("已转换"+res.percent+'%');
					$(".status-"+res.id+" .translate-status").css({
						width: res.percent * 1080 / 100 + 'px'
					})

					if (res.displayUpSpeedStatus == 1) {
						// 显示加速
						if ($(".table-item-"+res.id+" .speed-start").length ==0) {
							$(".table-item-"+res.id+"").html("<div class='speed speed-up speed-start' data-page="+res.pageCount+"><i class='i1'></i><i class='i2'></i>加速</div>");
						}
					}else if(res.displayUpSpeedStatus == 2){
						// 显示加速中
						if ($(".table-item-"+res.id+" .speed-up.active").length ==0) {
							$(".table-item-"+res.id+"").html("<div class='speed speed-up active' data-page="+res.pageCount+"><i class='i1'></i><i class='i2'></i>加速中</div>");
						}
					}else{
						// $(".table-item-"+res.id+"").html('<span class="cancel-doc">取消</span>');
					}
				}
			}else if(res.status == '1'){
				$(".status-"+res.id+" .icon-tip").removeClass("icon-wait").addClass("icon-finish");
				$(".status-"+res.id+" .tran-status-text").text("已完成");

				let success_operate = '<span class="down-pdf">下载</span><span class="del-doc">删除</span>';
				$(".table-item-"+res.id+"").html(success_operate);
				$(".status-"+res.id+" .translate-status").remove();
				$(".status-"+res.id+"").parents("tr").find("td .no-choose").removeAttr("disabled").removeClass("no-choose").addClass("can-choose");

				clearInterval(_this.data.table_timer[index]);
			}else if(res.status == '3'){
				$(".status-"+res.id+" .tran-status-text").text("校对中");
				$(".table-item-"+res.id+"").html('<span class="check-doc">校对</span>');

				$(".status-"+res.id+" .translate-status").remove();
				clearInterval(_this.data.table_timer[index]);
			}else{
				let err_question = '<span class="iconfont iconwenhao fail-tip-icon">'
						+'<span class="fail-tip-text">'+res.msg+'</span>'
						+'</span>';		

				$(".status-"+res.id+" .icon-tip").removeClass("icon-wait").addClass("icon-fail");
				$(".status-"+res.id+" .tran-status-text").text("转换失败");
				$(".status-"+res.id+" .translate-status").remove();
				if ($(".status-"+res.id+" .fail-tip-icon").length == 0) {
					$(".status-"+res.id+"").append(err_question);
				}
				
				if (res.status == "-12" || res.status == "-10") {
					let operate_item = '<span class="del-doc">删除</span>';
					$(".table-item-"+res.id+"").html(operate_item);
					return;
				}else{
					let operate_item = '<span class="del-doc">删除</span>';
					$(".table-item-"+res.id+"").html(operate_item);
					clearInterval(_this.data.table_timer[index]);
				}
			}
		},function(res){
			// _comMeds.autoCloseAlert(res.msg);
			// clearInterval(_this.data.table_timer);
		})
	},
	// 查询图片翻译进度
	queryTranslateImg : function(id,index){
		let _this = this;
		let subData = {
			taskId:id
		};

		_tran.getProgress(subData, function(res,msg){
			if (res.status == '0') {
				res.percent = _comMeds.fomatFloat(res.percent,2)
				// 等待或正在翻译中
				if (res.rank >= '1') {
					// 排队
					$(".status-"+res.id+" .tran-status-text").text('正在排队，前面还有'+res.rank+'人');
				}else{
					$(".status-"+res.id+" .tran-detail").hide();
					$(".detail-box-"+res.id+"").remove();
					
					$(".status-"+res.id+"").find(".icon-fail").removeClass("icon-fail").addClass("icon-wait");
					$(".status-"+res.id+" .tran-status-text").text("已翻译"+res.percent+'%');
					$(".status-"+res.id+" .translate-status").css({
						width: res.percent * 1080 / 100 + 'px'
					})
					// $(".table-item-"+res.id+"").html('<span class="cancel-doc">取消</span>');
				}
			}else if(res.status == '1'){
				$(".status-"+res.taskId+" .icon-tip").removeClass("icon-wait").addClass("icon-finish");
				$(".status-"+res.taskId+" .tran-status-text").text("已完成");

				let success_operate = '<span class="read-img">阅读</span><span class="down-img">下载</span><span class="del-tran-img">删除</span>';
				$(".table-item-"+res.taskId+"").html(success_operate);
				$(".status-"+res.taskId+" .translate-status").remove();
				$(".status-"+res.taskId+"").parents("tr").find("td .no-choose").removeAttr("disabled").removeClass("no-choose").addClass("can-choose");

				clearInterval(_this.data.table_timer[index]);
			}else{
				$(".status-"+res.taskId+" .icon-tip").removeClass("icon-wait").addClass("icon-fail");
				$(".status-"+res.taskId+" .tran-status-text").text("翻译失败");
				$(".status-"+res.taskId+" .translate-status").remove();
				
				if (res.status == "-12" || res.status == "-10") {
					let operate_item = '<span class="del-tran-img">删除</span>';
					$(".table-item-"+res.taskId+"").html(operate_item);
					return;
				}else{
					let operate_item = '<span class="del-tran-img">删除</span>';
					$(".table-item-"+res.taskId+"").html(operate_item);
					clearInterval(_this.data.table_timer[index]);
				}
			}
		},function(res){
			// _comMeds.autoCloseAlert(res.msg);
			// clearInterval(_this.data.table_timer);
		})
	},
	// 阅读
	readDoc : function(id){
		// var newWindow = window.open();
		// window.location.href = winPubPath + '/translate/readDoc.html?tid='+id;
		let url = winPubPath + '/translate/readDocs.html?tid='+id;
		window.open(url,"_blank");
	},
	readDocs : function(id){
		let url = winPubPath + '/translate/readDocs.html?tid='+id;
		window.open(url,"_blank");
	},
	readDocsPdf : function(id){
		let url = winPubPath + '/translate/readDocsPdf.html?tid='+id;
		window.open(url,"_blank");
	},
	// 图片阅读
	readImg(id){
		// window.location.href = winPubPath + '/translate/readImg.html?tid='+id;
		let url = winPubPath + '/translate/readImg.html?tid='+id;
		window.open(url,"_blank");
	},
	// 删除
	delDoc : function(id){	
		let _this = this;
		let subData = {
			tids:id
		};
		let str = '<div style="font-size: 16px;margin-top:30px;margin-bottom:13px;">确定删除所选文件？</div>'
				+'<div style="color: #75809D;font-size:12px;margin-bottom:23px;">文件保存至回收站'+_this.data.rubbishTime+'天后将被自动清除。</div>';

		_comMeds.zgAlert({
		    title:'提示',
		    content:str,
		    width:'440px',
		    yesText:'确定',
		    noText:'取消',
		    yesFn:function(e){
		    	_this.delLoading();
		        _tran.moveToRecycle(subData, function(res,msg){
		        	_this.data.chooseIds = [];
		        	$(".total-check").prop("checked",false);
		        	_this.delSuccess();
					$(".my-tran-box").hide();
					if(_this.data.node != '2'){
                        _this.getDocExpireCount("delete");
					} else {
						$('.maintable').dataTable().fnDraw(false);
					}
                    // if(_this.data.node == 1){
					// 	_this.getDocExpireCount("delete");
					// }
		        },function(res){
		        	_this.delFail();
		        })
		        $(".common-shadow-bg").remove();
		    },
		    noFn:function(e){
		        $(".common-shadow-bg").remove();
		    },
		    closeFn:function(e){
		        $(".common-shadow-bg").remove();
		    }
		});
	},
	// 删除文档
	delImg(id){
		let _this = this;
		let subData = {
			tids:id
		};
		let str = '<div style="font-size: 16px;margin:30px auto;">确定删除所选图片？</div>';
		_comMeds.zgAlert({
		    title:'提示',
		    content:str,
		    width:'440px',
		    yesText:'确定',
		    noText:'取消',
		    yesFn:function(e){
		    	_this.delLoading();
		    	_tran.imageDelete(subData,function(res){
		    		// $('.maintable').dataTable().fnDraw(false);
		    		_this.data.chooseIds = [];
		        	$(".total-check").prop("checked",false);
		    		_this.delSuccess();
					$(".my-tran-box").hide();
					_this.getDocExpireCount("delete");
		    	},function(res){
		    		_this.delFail();
		    	})
		        $(".common-shadow-bg").remove();
		    },
		    noFn:function(e){
		        $(".common-shadow-bg").remove();
		    },
		    closeFn:function(e){
		        $(".common-shadow-bg").remove();
		    }
		});
	},
	// 新人优惠翻译的文档 下载前先扣阅读费用
	getComputeInfo(tid){
		let _this = this;
		let subData = {
      ids: tid
    };
    _score.apiGetComputeInfo(subData, function(res,msg){
			// console.log(res)
			if(res.computeScoreVo.isEnough){
				_this.reduceTrans(tid)
				_comMeds.countLink(612,0, tid);
			}else if(res.computePageVo.isEnough){
				_this.reduceTrans(tid)
				_comMeds.countLink(612,0, tid);
			}else{
				_comMeds.countLink(610,0, tid);
				_comMeds.countLink(611);
				if(_this.data.transType){
					// Deepl不能使用新人权益 
					// sessionStorage.setItem("novaeHomines",'7')
				}else{
					// sessionStorage.setItem("novaeHomines",'3')
				}
				let a = {
					tid: tid,
					payItemCode: 100,
					payWay: 1,
				}
				sessionStorage.setItem("singlePayInfo",JSON.stringify(a))
				_this.data.fileStateOjb = res
				let accountInfoVo = _this.data.fileStateOjb.scoreAccountInfoVo
				let tabs = '';
				if((!accountInfoVo.isVipUser && !accountInfoVo.score && !accountInfoVo.specailPage) || (!accountInfoVo.isVipUser && !accountInfoVo.score && accountInfoVo.specailPage)){
					tabs = 1
				}else{
					if(accountInfoVo.score){
						tabs = 2
					}else{
						tabs = 4
					}
				}
				
				let payObj = {
					payTab: tabs,
					payIndex: 0,
					payFrom: 6,
					computePageVo: _this.data.fileStateOjb.computePageVo ,
					computeScoreVo: _this.data.fileStateOjb.computeScoreVo ,
					scoreAccountInfoVo: _this.data.fileStateOjb.scoreAccountInfoVo,
					docInfo: _this.data.docInfo
				}
				_allPayBox.payBox(payObj,function(){
					setTimeout(function() {
						console.log('-----,reload');
						_this.readload(tid)
					},2000)
					
				});
			}
		},function(res){

    })
	},
    
	// 批量/单文件下载
	downMulDoc : function(id,payItemCode,free,isChoose){
		let _this = this;
		$(".singleTransNow").css("cursor","no-drop")
        $(".mytran-box").hide()
        $(".select-box").show()
		let subData = {
			ids:id,
			payItemCode:payItemCode,
		};
		_score.multiCheckScore(subData, function(res,msg){
			
		},function(res){
			if (res.code < 0 && res.code != -2002016) {
				_comMeds.autoCloseAlert(res.msg);
				return false;
			}else{
				let isenough = 0 ,datas = [],docSize = 0,payAllScore =0,payAllPage=0,pagesNum=0,filesNum=res.data.fileScoreInfos.length;
				let pdfPayStatus = 0,wordPayStatus = 0,needPayId = [];
                if($('.downtable').hasClass("dataTable")) {
                    $('.downtable').dataTable().fnDestroy()
                }
                $.each(res.data.fileScoreInfos, (index, item) => {
                    payAllScore += item.payScore
                    payAllPage += item.payPage
                    pagesNum += item.pageCount
					// 有一个没付费 就变6 去支付
					if(pdfPayStatus == 0 && item.pdfPayStatus == 0 && item.isHavePdfFile != 0){
						pdfPayStatus = 6
					}
					if(wordPayStatus == 0 && item.wordPayStatus == 0 && item.isHaveWordFile != 0){
						wordPayStatus = 6
					}
					// 过滤没有文件 不要支付的文件id
					if((payItemCode == 200 && item.isHavePdfFile == 1) || (payItemCode != 200 && item.isHaveWordFile == 1)){
						needPayId.push(item.id)
					}
                })
                $(".s-p-loading").hide()
				if (res.code == -2002016) {
					isenough = 0;
                    $(".more-download-box .d-title").html('本次共下载<span class="payAllFiles">0</span>个文档，需扣除<span class="payAllScore">0</span>积分或<span class="payAllPages">0</span>页')
				    datas = [];
				}else{
                    $(".more-download-box .d-title").html('本次共下载<span class="payAllFiles">'+res.data.docSize+'</span>个文档，需扣除<span class="payAllScore">'+payAllScore+'</span>积分或<span class="payAllPages">'+payAllPage+'</span>页')
					isenough = res.data.isEnough;
					datas = res.data.fileScoreInfos;
					docSize = res.data.docSize;
				}
	
                $(".more-download-box").show()
				if (payItemCode == '200') {
					_this.renderTable(datas);
				}else if(payItemCode == '400'){
					_this.renderTableOffice(datas, 400);
				} else {
					_this.renderTableOffice(datas);
				}
				let typeCho = $(".r-c-box.active").find(".radio-choose").data("type")
				// && typeCho == 300
                // if(payAllScore <= 0) {
                if((typeCho == 300 && wordPayStatus == 0) ||(typeCho == 200 && pdfPayStatus == 0) ||(typeCho == 400 && wordPayStatus == 0&& pdfPayStatus == 0)) {
					// 不显示支付
					console.log('111111')
                    _this.data.isChoosed = 1
                    $(".btn_isFree").show()
                    $(".pay-types-box").hide()
                    $(".pay-types-cont").html('')
                    $(".btn_isFree").attr("data-filesnum",filesNum)
                }else {
					// 显示支付
                    $(".pay-types-box").show()
                    $(".btn_isFree").hide()
                    let c=0
                    if($('.score-type-cont').hasClass('active')) {
                        c=1
                    }else {
                        c=0
                    }
                    let str = $(".pay_num em").text()
                    if(isChoose) {
                        if(str=='vip页') {
                            $(".pay_num .vipy").text(payAllPage)
                        }else if(str=='特惠页') {
                            $(".pay_num .thy").text(payAllPage)
                        }else if(str=='vip页特惠页') {
                            let num = payAllPage-$(".all_vipy").text()
                            $(".pay_num .vipy").text($(".all_vipy").text())
                            $(".pay_num .thy").text(num)
                        }else if(str=='特惠页vip页') {
                            let num = payAllPage-$(".all_thy").text()
                            $(".pay_num .thy").text($(".all_thy").text())
                            $(".pay_num .vipy").text(num)
                        }else if(str=='积分') {
                            $(".pay_num .jf").text(payAllScore)
                        }
                        // if(c||_this.data.isChoosed) {//选择积分或切换过免费
                            _this.computeScoreFuc(needPayId.join(','),filesNum,pagesNum,payItemCode,free,c)
                        // }
                    }else {
                        _this.computeScoreFuc(needPayId.join(','),filesNum,pagesNum,payItemCode,free)

                    }
                    _this.data.isChoosed = 0
                }
			}
		})	
	},
	// 取消翻译
	cancelDoc : function(id,index){	
		let _this = this;
		let subData = {
			tid:id
		};
		let str = '<div style="padding:30px 0;font-size:16px;color:#031B4D;">您要取消正在翻译中的文件吗<br>一天最多取消3次！</div>';

		_comMeds.zgAlert({
		    title:'提示',
		    content:str,
		    width:'440px',
		    yesText:'确定',
		    noText:'取消',
		    yesFn:function(e){
		    	_this.delLoading();
		        _tran.cancelDoc(subData, function(res,msg){
		        	clearInterval(_this.data.table_timer[index]);
		        	$('.maintable').dataTable().fnDraw(false);
		        	_this.delSuccess("取消成功");
		        },function(res){
		        	_this.delFail(res.msg);
		        })
		        $(".common-shadow-bg").remove();
		    },
		    noFn:function(e){
		        $(".common-shadow-bg").remove();
		    },
		    closeFn:function(e){
		        $(".common-shadow-bg").remove();
		    }
		});
	},
	cancelPdf : function(id,index){	
		let _this = this;
		let subData = {
			tid:id
		};
		let str = '<div style="padding:30px 0;font-size:16px;color:#031B4D;">您要取消正在转换中的文件吗<br>一天最多取消3次！</div>';

		_comMeds.zgAlert({
		    title:'提示',
		    content:str,
		    width:'440px',
		    yesText:'确定',
		    noText:'取消',
		    yesFn:function(e){
		    	_this.delLoading();
		        _pdf.cancelDoc(subData, function(res,msg){
		        	clearInterval(_this.data.table_timer[index]);
		        	$('.maintable').dataTable().fnDraw(false);
		        	_this.delSuccess("取消成功");
		        },function(res){
		        	_this.delFail(res.msg);
		        })
		        $(".common-shadow-bg").remove();
		    },
		    noFn:function(e){
		        $(".common-shadow-bg").remove();
		    },
		    closeFn:function(e){
		        $(".common-shadow-bg").remove();
		    }
		});
	},
	// 回收站中彻底删除文档
	delMyRecycle : function(id){
		let _this = this;
		let subData = {
			tids:id
		};
		let str = '<div style="font-size: 16px;margin-top:30px;margin-bottom:13px;">确定删除所选文件？</div>'
				+'<div class="red" style="font-size:18px;margin-bottom:23px;">文件彻底删除后无法恢复！</div>';

		_comMeds.zgAlert({
		    title:'提示',
		    content:str,
		    width:'440px',
		    yesText:'确定',
		    noText:'取消',
		    yesFn:function(e){
		    	_this.delLoading();
		        _tran.delMyRecycle(subData, function(res,msg){
		        	$('.maintable').dataTable().fnDraw(false);
		        	_this.data.chooseIds = [];
		        	$(".total-check").prop("checked",false);
					_this.delSuccess();
					_this.getWillRestoreDoc();
					$('.top-btn-box .del-box').hide();
		        },function(res){
		        	_this.delFail();
		        })
		        $(".common-shadow-bg").remove();
		    },
		    noFn:function(e){
		        $(".common-shadow-bg").remove();
		    },
		    closeFn:function(e){
		        $(".common-shadow-bg").remove();
		    }
		});
	},
	// 校对
	checkDoc : function(id){
		// window.location.href = winPubPath + '/translate/catDoc.html?tid='+id;
		let url = winPubPath + '/translate/catDoc.html?tid='+id;
		window.open(url,"_blank");
	},
	// 重新翻译
	reTran : function(id,type,cont){
		let _this = this;

		_tranCommon.reTranCheckScore(id,type,function(){
			let subData = {
				tid:id
			};
  
            if(cont) {
                let subData = {
                    tid:id
                };
                _tran.reTrans(subData, function(res,msg){

                    $('.maintable').DataTable().draw(false);
                    $('.common-shadow-bg').remove();
                },function(res){
                    _comMeds.autoCloseAlert(res.msg);
                })
            }else {
                _comMeds.zgAlert({
                    title:'提示',
                    content:'<p style="margin:40px auto;">重新翻译将扣除翻译积分，确定翻译吗？</p>',
                    width:'440px',
                    noText:'取消',
                    yesText:'确定',
                    yesFn:function(e){
                        let subData = {
                            tid:id
                        };
                        _tran.reTrans(subData, function(res,msg){
                            /*_this.data.table_timer = setInterval(function(){
                                _this.queryTranslateDoc(id);
                            }, 2000);*/
                            $('.maintable').DataTable().draw(false);
                            // _this.getMyTranslate(1);
                        },function(res){
                            _comMeds.autoCloseAlert(res.msg);
                        })
                        $(".common-shadow-bg").remove();
                    },
                    noFn:function(e){
                        $(".common-shadow-bg").remove();
                    },
                    closeFn:function(e){
                        $(".common-shadow-bg").remove();
                    }
                });                
            }


		})
	},
	// 获取文档剩余存储天数
	getDocExpireDays : function(id){
		let _this = this;
		let subData = {
			tid:id
		};
		_tran.getDocExpireDays(subData, function(res,msg){
			if (res.remainDays == 0) {
				if (res.memberCoin > 0) {
					// 轻寻豆足够
					var str = '轻寻豆：'+ res.memberCoin;
					_this.restoreDoctip(str,id);
					return;
				}else{
					// 轻寻豆不足
					_this.restoreDocBuGoutip();
				}
			}else{
				_this.restoreDocEnoughTip(res.remainDays,id);
			}
			
		},function(res){
			_comMeds.autoCloseAlert(res.msg);
		})
	},
	// 恢复文档
	restoreDocReq : function(id){
		let _this = this;
		let subData = {
			tid:id
		};
		_tran.recoverDoc(subData, function(res,msg){
        	$('.maintable').dataTable().fnDraw(false);
        	_this.delSuccess("恢复成功");
        },function(res){
        	_this.delFail("恢复失败");
        })
	},
	// 恢复文档青寻豆足够提示
	restoreDoctip : function(dou_str,id){
		let _this = this;
	    var str = '<p style="padding:30px 26px 20px 26px;">本文档已无剩余时长，若要恢复需要扣除'
	        +'<span style="color:#FC8300">1</span>个轻寻豆，恢复后可存放'
	        +'<span style="color:#FC8300">1</span>天</p>'
	        +'<p style="color:#FC8300;">'+dou_str+'</p>';
	    _comMeds.zgAlert({
	        title:'提示',
	        content:str,
	        width:'440px',
	        noText:'取消',
	        yesText:'确定',
	        yesFn:function(e){
	            _this.restoreDocReq(id);
	            $(".common-shadow-bg").remove();  
	        },
	        noFn:function(e){
	            $(".common-shadow-bg").remove();
	        },
	        closeFn:function(e){
	            $(".common-shadow-bg").remove();
	        }
	    });
	},
	// 恢复文档青寻豆不够提示
	restoreDocBuGoutip : function(){
	    var str = '<p style="padding:35px 26px;">很抱歉，轻寻豆不足，无法恢复本文档。</p>';
	    _comMeds.zgAlert({
	        title:'提示',
	        content:str,
	        width:'440px',
	        yesText:'确定',
	        yesFn:function(e){
	            $(".common-shadow-bg").remove();
	        },
	        closeFn:function(e){
	            $(".common-shadow-bg").remove();
	        }
	    });
	},
	// 根据文档剩余天数提示
	restoreDocEnoughTip : function(day,id){
		let _this = this;
	    if (day > 0) {
	        var str = '<p style="padding:30px 26px;">确认恢复选中的文档吗？<br/>本文档恢复后可继续存放<span style="color:#FC8300">'+day+'</span>天</p>';
	    }else if(day < 0){
	        var str = '<p style="padding:30px 26px;">确认恢复选中的文档吗？</p>';
	    }

	    _comMeds.zgAlert({
	        title:'提示',
	        content:str,
	        width:'440px',
	        noText:'取消',
	        yesText:'确定',
	        yesFn:function(e){
	            _this.restoreDocReq(id);
	            $(".common-shadow-bg").remove();
	        },
	        noFn:function(e){
	            $(".common-shadow-bg").remove();
	        },
	        closeFn:function(e){
	            $(".common-shadow-bg").remove();
	        }
	    });
	},

	// 正在删除中提示窗
	delLoading : function(text){
		if (text == '' || text == undefined) {
			text = "正在删除文件，请稍后…";
		}
		let str = '<div class="del-finish-tip"><span class="tip-icon loading">'
				+'</span><span class="loading-text">'+text+'</span></div>';
		$("body").append(str);
	},
	// 删除成功提示窗
	delSuccess : function(text){
		if ($(".del-finish-tip")) {
			if (text == '' || text == undefined) {
				text = "删除成功";
			}
			$(".del-finish-tip").empty();
			let str = '<span class="success"></span>'+text;
			$(".del-finish-tip").append(str);
			setTimeout(function(){
				$(".del-finish-tip").remove();
			},1500)
		}
	},
	// 删除失败提示窗
	delFail : function(text){
		if ($(".del-finish-tip")) {
			if (text == '' || text == undefined) {
				text = "删除失败";
			}
			$(".del-finish-tip").empty();
			let str = '<span class="iconfont iconcha del-fail"></span>'+text;
			$(".del-finish-tip").append(str);
			setTimeout(function(){
				$(".del-finish-tip").remove();
			},1500)
		}
	},
	// 设置拆分翻译进度
	setTranProgress : function(id){
		let subData = {
			tid:id
		};
		_tran.getTransDetail(subData, function(res,msg){			
			if (res != '') {
				var datas = res;
				var str = '',item = '',square = '';
				var already_tran=0,in_tran=0,err_tran=0;
				if (datas.page != datas.pageList.length) {
				}

				for (var i = 0; i < datas.page; i++) {
                    if (datas.pageList[i].state == 1) {
                        item = '<div class="page-pro active"></div>';
                        already_tran++;
                    }else if(datas.pageList[i].state == 0){
                        item = '<div class="page-pro" style="width:'+datas.pageList[i].percent+'%;"></div>';
                        in_tran++;
                    }else{
                        item = '<div class="page-pro error"></div>';
                        err_tran++;
                    }

                    square = '<span class="square" data-status="'+datas.pageList[i].state+'" data-current="'+datas.pageList[i].current+'" data-msg="'+datas.pageList[i].msg+'">'+item+'</span>';
                    str += square; 
				}
				$(".left-wrap-scroll").empty().append(str);

				var already_per = ((already_tran/datas.page)*100).toFixed(2)+'%';
				var intran_per = ((in_tran/datas.page)*100).toFixed(2)+'%';
				var err_per = ((err_tran/datas.page)*100).toFixed(2)+'%';

				$(".right-wrap .percent1").text(already_per);
				$(".right-wrap .percent2").text(intran_per);
				$(".right-wrap .percent3").text(err_per);
				// model大于等于130翻译完成
				if (datas.model >= 130) {
				    $("#t_"+id).find(".tran-detail").remove();
				    $(".pro-detail-box").remove();
				}

				$(".right-wrap .page").text(datas.page);
				$(".right-wrap .line-con1").css({
				    "width":already_per
				});
				$(".right-wrap .line-con2").css({
				    "width":intran_per
				});
				$(".right-wrap .line-con3").css({
				    "width":err_per
				});
			}
		},function(res){
			_comMeds.autoCloseAlert(res.msg);
		})
	},
	// 搜索请求
	searchRecode : function(){
		let type = $(".top-toggle li.active").data("type");
		$('.maintable').DataTable().destroy();
		if (type == '1') {
			if (this.data.isChooseExprice == '0') {
				this.getMyTranslate(type);
			}else{
				this.getMyTranslate(11);
			}
		}else if(type == '2'){
			let type2 = $(".erji-huishou div.active").data("type");
			this.getMyRecycleList(type2);
		}else if(type == '3'){
			if (this.data.isChooseExprice == '0') {
				this.getImgTranList(type);
			}else{
				this.getMyTranslate(11);
			}
		} else if(type == 7){  // 格式转换
			if (this.data.isChooseExprice == '0') {
				this.getPdfList();
			} else {
                this.getPdfList(11);
			}
		}
	},
	// 批量操作
	mulOperate : function(ids){
		let count = $(".check-item input:checkbox:checked").length;
		let count_tr = $(".table-box tbody tr").length - $(".table-box tbody .no-choose").length;

		if (count < count_tr) {
			$(".total-check").prop("checked",false);
		}else if(count == count_tr){
			$(".total-check").prop("checked",true);
		}
		if (ids.length > 1) {
			// 显示批量下载和批量删除及右侧操作
			$(".maintable .operate-box").hide();

			if(this.data.node == '1'){
				$(".top-toggle .my-tran-box").show();
			}else if(this.data.node == '2'){
				$(".top-toggle .del-box").show();
			}else if(this.data.node == '7' || this.data.node == '3'){
				$(".top-toggle .my-tran-box").show();
			}else{
				$(".top-toggle .my-tran-box").hide();
				$(".top-toggle .del-box").hide();
			}
		}else{
			$(".maintable .operate-box").show();
			if(this.data.node == '1'){
				$(".top-toggle .my-tran-box").hide();
			}else if(this.data.node == '2'){
				$(".top-toggle .del-box").hide();
			} else if(this.data.node == '7' || this.data.node == '3'){
				$(".top-toggle .my-tran-box").hide();
			}
			
		}
	},
	// 获取文档将要过期的天数
	getDocExpireCount : function(type){
		let _this = this;
		let docSource = '';
		if(_this.data.node == 1){
			docSource = '';
		} else if(_this.data.node == 7){
			docSource = -3;
		} else if(_this.data.node == 3){
			docSource = -2;
		}
		var subData = {
			docSource: docSource
		}
		_tran.getDocExpireCount(subData, function(res,msg){
			if (res) {
				if (res.expireCount > 0) {
					_this.data.timeReqCount++;

					let count = res.expireCount;
                    let time = res.recentExpireDay
					_this.data.expireCount = count;
                    _this.data.recentExpireDay = time
                    let popRubbishTime = res.recycleDays
					$(".timeout-tip>p span").text(count);
					$(".timeout-tip").show();
					if (res.popup == 1) {
                        setTimeout(function() {
                            _this.fileExpericeBox(count, time, popRubbishTime);
                        },200)
					}
					if(type == 'delete'){
						$('.maintable').dataTable().fnDraw(false);
					}
				}else{
					$(".timeout-tip>p span").text(0);
					$(".timeout-tip").hide();
					if ($(".timeout-tip .is-check-guoqi").hasClass("iconxuanzhong1")) {
						$(".timeout-tip .is-check-guoqi").removeClass("iconxuanzhong1").addClass("iconoval");
					}
					if (type == 'delete') {
						// 如果删除后列表为空，显示我的翻译列表
						$('.maintable').DataTable().destroy();
						if(_this.data.node == '1'){
						   _this.getMyTranslate(1);
						} else if(_this.data.node == '3'){
							_this.getImgTranList(3);
						} else if(_this.data.node == '7'){
							_this.getPdfList();
						}
					}
				}
			}
		},function(res){
			_comMeds.autoCloseAlert(res.msg);
		})
	},
	// 未登录样式
	unLogin : function(){
		$(".mytran-box,.select-box").hide();
		$(".unlogin-box").show();
	},
	// 引入右侧反馈导航
	addFeedBack : function(){
		_feedBackBox.init();
		_feedBackBox.addRightFeedBack();
	},
	// 渲染下载的表格
	renderTable : function(tableList){
		let grey;
		if (tableList.length > 0) {
			$(".before-load-table").hide();
		}else if (tableList.length == 0){
			$(".before-load-table").hide();
		}
		if(JSON.parse(localStorage.getItem('userInfo')).memberStatus.memberType.memberType != 'month'){
			grey = 'grey';
		} else {
			grey = '';
		}
		let exlsNum=0//记录多文件不能下载的文件个数
		$('.downtable').DataTable({
		    data: tableList,
		    autoWidth:false, // 控制Datatables是否自适应宽度
		    info: true, // 控制是否显示表格左下角的信息
		    lengthChange:true, // 是否允许用户改变表格每页显示的记录数
		    lengthMenu:[10],
		    ordering:false, // 是否允许Datatables开启排序
		    paging:false, // 是否开启本地分页
		    serverSide:false, // 是否开启服务器模式
		    pagingType: "simple_numbers",
		    dom: 't<"table-bottom-box clearfix"i>',
		    stateSave: true, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
		    searching:false, // 是否允许Datatables开启本地搜索
		    columns: [
		        { 
		        	title:"文档名",
		        	data: 'fileName',
		        	width:'20%',
		        	className:'align-left',
		        },
		        {
		        	title:"<span class='r-c-box'><span class='radio-choose' data-type='300'></span>office文档<div class='question-box'><span class='iconfont iconwenhao huishou-tip'><span class='message-tip'>html文档下载时仅支持html格式</span></span></div></span>",
		        	width:'18%',
		        	className:'align-center',
		        	data: '',
		        	render:function(data,type,row,meta){
						if(row.isHaveWordFile == 1){
							return '<span class="mul-down-choose mul-word"><i class="iconfont icondingbuchenggongtishi"></i></span>';
						} else {
							return '<span class="mul-down-choose mul-word"><i class="iconfont icondingbushibaitishi"></i></span>';
						}
		        	}
		        },
                {
		        	title:"<span class='r-c-box active'><span class='radio-choose' data-type='200'></span>PDF文档</span>",
		        	width:'18%',
		        	className:'align-center',
		        	data: '',
		        	render:function(data,type,row,meta){
						if(row.isHavePdfFile == 1){
                            $(".btn_isFree").css({
                                "opacity":"1",
                                "cursor":"pointer"
                            }).removeAttr("disabled");
							return '<span class="mul-down-choose mul-pdf active"><i class="iconfont icondingbuchenggongtishi"></i></span>';
						} else {
                            exlsNum++
                            if(tableList.length==1) {
                                $(".btn_isFree").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                            }
                            return '<span class="mul-down-choose mul-pdf active"><i class="iconfont icondingbushibaitishi"></i></span>';                                

						}
		        		
		        	}
		        },
				{
		        	title:"<span class='r-c-box'><span class='radio-choose pdf-office-radio' data-type='400'></span>Office+PDF<span class='r-c-spa'>VIP</span></span>",
		        	width:'18%',
		        	className:`align-center ${grey}`,
		        	data: '',
		        	render:function(data,type,row,meta){
						if(row.isHavePdfFile == 1 && row.isHaveWordFile == 1){
							return '<span class="mul-down-choose mul-office-pdf"><i class="iconfont icondingbuchenggongtishi"></i></span>';
						} else if(row.isHavePdfFile == 1){
							return '<span class="mul-down-choose mul-office-pdf">有PDF文档</span>'
						} else if(row.isHaveWordFile == 1){
							return '<span class="mul-down-choose mul-office-pdf">有Office文档</span>'
						} else {
							return '<span class="mul-down-choose mul-office-pdf"><i class="iconfont icondingbushibaitishi"></i></span>';
						}
		        	}
		        },
		        {
		        	title:"页数",
		        	width:'10%',
		        	className:'align-center',
		        	data: 'pageCount' 
		        },
		        {
		        	title:"所需积分或页数",
		        	width:'16%',
		        	className:'align-center',
		        	data: '',
                    render:function (data,type,row,meta) {  
                        return ''+ row.payScore +'积分 / '+ row.payPage +'页'
                    }
		        }
		    ]
		});
        if(tableList.length==exlsNum) {
            $(".btn_isFree").css({
                "opacity":"0.2",
                "cursor":"default"
            }).attr("disabled","true");
        }

		$(".more-download-box .table-bottom-box").hide();		
	},
	// 切换office渲染表格
	renderTableOffice : function(tableList, type){
		let active1, active2, grey;
		if(type && type == 400){
			active1 = '';
			active2 = 'active'
		} else {
			active1 = 'active';
			active2 = ''
		}
		if(JSON.parse(localStorage.getItem('userInfo')).memberStatus.memberType.memberType != 'month'){
			grey = 'grey';
		} else {
			grey = '';
		}
		if (tableList.length > 0) {
			$(".before-load-table").hide();
		}
        let docNum=0,doubleNum=0
		$('.downtable').DataTable({
		    data: tableList,
		    autoWidth:false, // 控制Datatables是否自适应宽度
		    info: true, // 控制是否显示表格左下角的信息
		    lengthChange:true, // 是否允许用户改变表格每页显示的记录数
		    lengthMenu:[10],
		    ordering:false, // 是否允许Datatables开启排序
		    paging:false, // 是否开启本地分页
		    serverSide:false, // 是否开启服务器模式
		    pagingType: "simple_numbers",
		    dom: 't<"table-bottom-box clearfix"i>',
		    stateSave: true, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
		    searching:false, // 是否允许Datatables开启本地搜索
		    columns: [
		        { 
		        	title:"文档名",
		        	data: 'fileName',
		        	width:'20%',
		        	className:'align-left',
		        },
                {
		        	title:`<span class='r-c-box ${active1}'><span class='radio-choose' data-type='300'></span>office文档<div class="question-box"><span class="iconfont iconwenhao huishou-tip"><span class="message-tip">html文档下载时仅支持html格式</span></span></div></span>`,
		        	width:'18%',
		        	className:'align-center',
		        	data: '',
		        	render:function(data,type,row,meta){
		        		if(row.isHaveWordFile == 1){
                            if(type != 400) {
                                $(".btn_isFree").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                            }
							return `<span class="mul-down-choose mul-word ${active1}"><i class="iconfont icondingbuchenggongtishi"></i></span>`;
						} else {
                            docNum++
                            if(type != 400&&tableList.length==1) {
                                $(".btn_isFree").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                            }
							return `<span class="mul-down-choose mul-word ${active1}"><i class="iconfont icondingbushibaitishi"></i></span>`;
						}
		        	}
		        },
		        {
		        	title:"<span class='r-c-box'><span class='radio-choose' data-type='200'></span>PDF文档</span>",
		        	width:'18%',
		        	className:'align-center',
		        	data: '',
		        	render:function(data,type,row,meta){
		        		if(row.isHavePdfFile == 1){
							return '<span class="mul-down-choose mul-pdf"><i class="iconfont icondingbuchenggongtishi"></i></span>';
						} else {
							return '<span class="mul-down-choose mul-pdf"><i class="iconfont icondingbushibaitishi"></i></span>';
						}
		        	}
		        },
				{
		        	title:`<span class='r-c-box ${active2}'><span class='radio-choose pdf-office-radio' data-type='400'></span>Office+PDF<span class='r-c-spa'>VIP</span></span>`,
		        	width:'18%',
		        	className:`align-center ${grey}`,
		        	data: '',
		        	render:function(data,type,row,meta){
                        if(type == 400) {
                            $(".btn_isFree").css({
                                "opacity":"1",
                                "cursor":"pointer"
                            }).removeAttr("disabled");
                        }
		        		if(row.isHavePdfFile == 1 && row.isHaveWordFile == 1){
							return `<span class="mul-down-choose mul-office-pdf ${active2}"><i class="iconfont icondingbuchenggongtishi"></i></span>`;
						} else if(row.isHavePdfFile == 1){
							return `<span class="mul-down-choose mul-office-pdf ${active2}">有PDF文档</span>`
						} else if(row.isHaveWordFile == 1){
							return `<span class="mul-down-choose mul-office-pdf ${active2}">有Office文档</span>`
						} else {
                            if(type == 400&&tableList.length==1) {
                                doubleNum++
                                $(".btn_isFree").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                            }
							return `<span class="mul-down-choose mul-office-pdf ${active2}"><i class="iconfont icondingbushibaitishi"></i></span>`;
						}
		        	}
		        },
		        {
		        	title:"页数",
		        	width:'10%',
		        	className:'align-center',
		        	data: 'pageCount' 
		        },
		        {
		        	title:"所需积分或页数",
		        	width:'16%',
		        	className:'align-center',
		        	data: '',
                    render:function (data,type,row,meta) {  
                        return ''+ row.payScore +'积分 / '+ row.payPage +'页'
                    }
		        }
		    ]
		});
        if(tableList.length==docNum||tableList.length==doubleNum) {
            $(".btn_isFree").css({
                "opacity":"0.2",
                "cursor":"default"
            }).attr("disabled","true");
        }
		$(".more-download-box .table-bottom-box").hide();
	},
    //下载结算方式选择（页数和积分）
    computeScoreFuc(id,filesNum,pagesNum,filestype,free,scoreOrPages) {
        console.log('duoduoduoduoduo')
        $(".mytran-box").hide()
        let _this = this
        let str = ''
        let a, aClass, b, bClass, c, cClass
        // 推荐
        let i1 = '',i2 = ''
        // 页数组合记录
        let payTypes = 0
        // 付费方式
        let reduceCode
        // 单次付费补足方式
        let singlePayType
        let down_score_type = 0
        let freeStr
        if(free == 1) {
            freeStr = ""
        }else {
            freeStr = "（翻译积分不做返还）"
        }
        //单文件
        if(filesNum == 1) {
            let subData = {
                pdfId: id
            }
            _score.computeScore(subData, res => {
				$(".singleTransNow").css("cursor","pointer")
                let dbScore
                if(filestype == 200) {
                    dbScore = res.payDownloadPdfScore
                }else {
					if(filestype == 400 && res.downloadWordPayStatus) {
						dbScore = 0;
					}else{
						dbScore = res.payDownloadWordScore
					}
                }
				// dbScore = res.payScore;
                // 页数
                if(res.userVipPage > 0) {
                    a = "余额：<span class='all_vipy' style='color: #FF5E52'>"+ res.userVipPage +"页</span>（"+ _comMeds.formatTime(res.currentVipPageExpireTime).substring(0,10) +"到期）"
                    aClass = ''
                }else {
                    a = "余额：0页"
                    aClass = 'disabledSty'
                }

                if(res.userSpecialPage > 0) {
                    b = "余额：<span class='all_thy' style='color: #FF5E52'>"+ res.userSpecialPage +"页</span>（"+ _comMeds.formatTime(res.currentSpecailPageExpireTime).substring(0,10) +"到期）"
                    bClass = ''
                }else {
                    b = "余额：0页"
                    bClass = 'disabledSty'
                }

                // 积分
                if(res.userAllScore > 0) {
                    c = "余额：<span style='color: #FF5E52'>"+ res.userAllScore +"积分</span>"
                    cClass = ''
                    down_score_type=1
                    i1 = require("../../../assets/images/tran/220301/tj_icon.png")
                }else {
                    if(dbScore <= 0) {
                        cClass = ''
                    }else {
                        cClass = 'disabledSty'
                    }
                    c = "余额：0积分"
                    if(res.userVipPage > 0) {
                        i2 = require("../../../assets/images/tran/220301/tj_icon.png")
                    }
                } 

                
                str = `<div class="select-pay-type-cont">
                            <!-- 积分选择 -->
                            <div class="score-type-cont">
                                <div class="${cClass} score-type sameOperate" data-type="3">
                                    <i class="iconfont iconoval"></i>
                                    <span>积分结算</span>
                                    <span class="score_pages_num">${c}</span>
                                    <img src="${i1}" alt="">
                                </div>
                            </div>
                            <!-- 页数选择 -->
                            <div class="pages-type-cont">
                                <div class="${aClass} vip-type sameOperate" data-type="1">
                                    <i class="iconfont iconoval"></i>
                                    <span>VIP页结算</span>
                                    <span class="vip_pages_num">${a}</span>
                                    <img src="${i2}" alt="">
                                </div>
                                <div class="${bClass} special-type sameOperate" data-type="2">
                                    <i class="iconfont iconoval"></i>
                                    <span>特惠页结算</span>
                                    <span class="special_pages_num">${b}</span>
                                </div>
                            </div>

                        </div>

                        <p class="s_p_t_p2">
                            <span class="single_pay" style="display: none">单次付费</span>
                            <span class="pay_num"></span> 
                        </p>
                        <div class="btns">
                            <button class="singlePayNow" disabled="true">立即充值</button>
                            <button class="singleTransNow" disabled="true">立即下载</button>
                        </div>`
                $(".s-p-loading").hide()
                $(".pay-types-cont").html(str)
				if(!this.data.isShowSingle){
					$(".single_pay").remove()
				}
                // 三个余额都为0时
                if(res.userVipPage <= 0 && res.userSpecialPage <= 0 && res.userAllScore <= 0) {
                    $(".single_pay").css("display","block")
                    $(".singlePayNow").css({
                        "opacity":"1",
                        "cursor":"pointer"
                    }).removeAttr("disabled");
                    singlePayType = 1
                }
                // 只有一种余额时默认勾选
                // 默认vip
                if(res.userVipPage > 0&&res.userSpecialPage <= 0&&res.userAllScore <= 0) {
                    $(".vip-type .iconoval").addClass('iconxuanzhong1').removeClass('iconoval')
                    $(".pages-type-cont").addClass('active')
                    if(res.payPage > res.userVipPage) {
                        payTypes = -1
                        _comMeds.autoCloseAlert("余额不足请选择组合支付方式!");
                        $(".singleTransNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".singlePayNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".pay_num").html('')
                    }else {
                        reduceCode = 3
                        $(".singleTransNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".singlePayNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="vipy">'+ res.payPage +'</span><em>vip页</em>'+ freeStr +'')
                    }
                }
                // 默认特惠页
                if(res.userSpecialPage > 0&&res.userVipPage <= 0&&res.userAllScore <= 0) {
                    $(".special-type .iconoval").addClass('iconxuanzhong1').removeClass('iconoval')
                    $(".pages-type-cont").addClass('active')
                    if(res.payPage > res.userSpecialPage) {
                        payTypes = -2
                        _comMeds.autoCloseAlert("余额不足请选择组合支付方式!");
                        $(".singleTransNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".singlePayNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".pay_num").html('')
                    }else {
                        reduceCode = 2
                        $(".singleTransNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".singlePayNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="thy">'+ res.payPage +'</span><em>特惠页</em>'+ freeStr +'')
                    }
                }
                // 默认积分
                if((res.userAllScore > 0&&res.userVipPage <= 0&&res.userSpecialPage <= 0)||scoreOrPages==1||down_score_type==1) {
                    $(".score-type .iconoval").addClass('iconxuanzhong1').removeClass('iconoval')
                    $(".score-type-cont").addClass("active")
                    if(dbScore > res.userAllScore) {
                        payTypes = 0
                        _comMeds.autoCloseAlert("余额不足，请立即充值!");
                        $(".singleTransNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".singlePayNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".single_pay").css("display","block")
                        singlePayType = 1
                        $(".pay_num").html('')
                    }else {
                        reduceCode = 1
                        $(".singleTransNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".singlePayNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="jf">'+ dbScore +'</span><em>积分</em>')
                    }
                }

                // 点击选择页数付费方式
                $(".sameOperate").unbind("click").bind("click", function (e) { 
                    e.stopPropagation()
                    e.preventDefault() 
                    let type = $(this).data("type")

                    if(!$(this).find('i').hasClass('iconxuanzhong1')) {
                        $(".sameOperate").each(function () {  
                            $(this).find("i").removeClass('iconxuanzhong1').addClass('iconoval')
                            $(this).parent().removeClass('active')
                        })
                        $(this).find('i').addClass('iconxuanzhong1').removeClass('iconoval')
                        $(this).parent().addClass('active')
                    }

                    // 页数判断vip
                    if(type == 1) {
                        $(".single_pay").css("display","none")
                        // vip页数
                        if(payTypes == -2) {//先点击特惠页数不够
                            $(".pages-type-cont .sameOperate").each(function () {  
                                $(this).find("i").addClass('iconxuanzhong1').removeClass('iconoval')
                                $(this).css("pointer-events","none")
                            })
                            if(res.payPage > res.userSpecialPage + res.userVipPage) {
                                _comMeds.autoCloseAlert("余额不足，请立即充值!");
                                $(".singleTransNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".singlePayNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                singlePayType = 4
                                $(".single_pay").css("display","block")
                                $(".pay_num").html('')
                            }else {
                                reduceCode = 4
                                $(".singleTransNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".singlePayNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                let num = res.payPage - res.userSpecialPage
                                $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="thy">'+ res.userSpecialPage +'</span><em>特惠页</em>+<span class="vipy">'+ num +'</span><em>vip页</em>'+ freeStr +'')
                            }
                        }else {

                            if(res.payPage > res.userVipPage) {
                                payTypes = -1
                                if(res.userSpecialPage <= 0) {//特惠页为0
                                    _comMeds.autoCloseAlert("余额不足，请立即充值!");
                                    singlePayType = 4
                                    $(".single_pay").css("display","block")
                                }else {
                                    _comMeds.autoCloseAlert("余额不足请选择组合支付方式!"); 
                                }
                                $(".singleTransNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".singlePayNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".pay_num").html('')
                            }else {
                                reduceCode = 3
                                $(".singleTransNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".singlePayNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="vipy">'+ res.payPage +'</span><em>vip页</em>'+ freeStr +'')
                            }
                        }

                    }
                    // 页数判断特惠
                    if(type == 2) {
                        $(".single_pay").css("display","none")
                        if(payTypes == -1) {//先点击vip页数不够
                            $(".pages-type-cont .sameOperate").each(function () {  
                                $(this).find("i").addClass('iconxuanzhong1').removeClass('iconoval')
                                $(this).css("pointer-events","none")
                            })
                            if(res.payPage > res.userSpecialPage + res.userVipPage) {
                                _comMeds.autoCloseAlert("余额不足，请立即充值!");
                                $(".singleTransNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".singlePayNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                singlePayType = 5
                                $(".single_pay").css("display","block")
                                $(".pay_num").html('')
                            }else {
                                reduceCode = 5
                                $(".singleTransNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".singlePayNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                let num = res.payPage - res.userVipPage
                                $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="vipy">'+ res.userVipPage +'</span><em>vip页</em>+<span class="thy">'+ num +'</span><em>特惠页</em>'+ freeStr +'')
                            }
                        }else {

                            if(res.payPage > res.userSpecialPage) {
                                payTypes = -2
                                if(res.userVipPage <= 0) {//vip页为0
                                    _comMeds.autoCloseAlert("余额不足，请立即充值!");
                                    singlePayType = 5
                                    $(".single_pay").css("display","block")
                                }else {
                                    _comMeds.autoCloseAlert("余额不足请选择组合支付方式!"); 
                                }
                                $(".singleTransNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".singlePayNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".pay_num").html('')
                            }else {
                                reduceCode = 2
                                $(".singleTransNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".singlePayNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="thy">'+ res.payPage +'</span><em>特惠页</em>'+ freeStr +'')
                            }
                        }

                    }
                    // 积分判断
                    if(type == 3) {
                        $(".single_pay").css("display","none")
                        payTypes = 0
                        $(".pages-type-cont .sameOperate").each(function () {  
                            if(!$(this).hasClass("disabledSty")) {
                                $(this).css("pointer-events","all")
                            }
                        })

                        if(dbScore > res.userAllScore) {
                            _comMeds.autoCloseAlert("余额不足，请立即充值!");
                            $(".singleTransNow").css({
                                "opacity":"0.2",
                                "cursor":"default"
                            }).attr("disabled","true");
                            $(".singlePayNow").css({
                                "opacity":"1",
                                "cursor":"pointer"
                            }).removeAttr("disabled");
                            $(".single_pay").css("display","block")
                            singlePayType = 1
                            $(".pay_num").html('')

                        }else {
                            reduceCode = 1
                            $(".singleTransNow").css({
                                "opacity":"1",
                                "cursor":"pointer"
                            }).removeAttr("disabled");
                            $(".singlePayNow").css({
                                "opacity":"0.2",
                                "cursor":"default"
                            }).attr("disabled","true");
                            $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="jf">'+ dbScore +'</span><em>积分</em>')
                        }
                    }
                    
                })
                
                // 点击立即下载
                $(".singleTransNow").unbind("click").bind("click",_comMeds.throttle(function(e) {
                    _this.officalWebsiteFuc(id, reduceCode, filestype)
                }))

                // 点击单次付费
                $(".single_pay").unbind("click").click(function() {
                    // window.location = winPubPath + '/pay/singlePay.html?tid='+id+'&payItemCode='+filestype+'&payWay='+singlePayType;
					let a = {
						tid: id,
						payItemCode: filestype,
						payWay: singlePayType,
					}
					sessionStorage.setItem("singlePayInfo",JSON.stringify(a))
					let payObj = {
						payTab: 6,
						payIndex: 1,
						payFrom: 0,
					}
					_allPayBox.payBox(payObj,function(){
						if($(".tab_boxs.active").data("num") == 6){
							// window.location.href = winPubPath + '/person/myfiles.html';
							if(String(id).indexOf(",") != -1) {//单文件下载
								_this.downloadAllTrans(id,filestype,1)
							}else {
								_this.downLoad(id,filestype,1)
							}
						}else{
							$(".r-c-box.active .radio-choose").click()
						}
					});
                })

                // 点击立即充值
                $(".singlePayNow").unbind("click").bind("click",_comMeds.throttle(function(e){
                    let isVip = JSON.parse(localStorage.getItem('userInfo')).memberStatus.memberType.memberType
                    console.log(isVip ,reduceCode)
                    if(reduceCode == 1) {
						let payObj = {
							payTab: 2,
							payIndex: 0,
							payFrom: 0,
						}
                        _allPayBox.payBox(payObj,function(){
							$(".r-c-box.active .radio-choose").click()
						})
                    }else {
						let payObj = {
							payTab: 4,
							payIndex: 0,
							payFrom: 0,
						}
                        if(isVip == 'month') {
							payObj.payTab = 4
                            _allPayBox.payBox(payObj,function(){
								$(".r-c-box.active .radio-choose").click()
							})
                        }else {
							payObj.payTab = 1
                            _allPayBox.payBox(payObj,function(){
								$(".r-c-box.active .radio-choose").click()
							})
                        }
                    }
                    
                }))


            })
        }else {
        //多文件
            let subData = {
                pdfIds: id,
                type: filestype
            }
            _score.officalWebsiteForBatch(subData, res => {
                // 页数
                if(res.userVipPage > 0) {
                    a = "余额：<span class='all_vipy' style='color: #FF5E52'>"+ res.userVipPage +"页</span>（"+ _comMeds.formatTime(res.currentVipPageExpireTime).substring(0,10) +"到期）"
                    aClass = ''
                }else {
                    a = "余额：0页"
                    aClass = 'disabledSty'
                }

                if(res.userSpecialPage > 0) {
                    b = "余额：<span class='all_thy' style='color: #FF5E52'>"+ res.userSpecialPage +"页</span>（"+ _comMeds.formatTime(res.currentSpecailPageExpireTime).substring(0,10) +"到期）"
                    bClass = ''
                }else {
                    b = "余额：0页"
                    bClass = 'disabledSty'
                }

                // 积分
                if(res.userAllScore > 0) {
                    c = "余额：<span style='color: #FF5E52'>"+ res.userAllScore +"积分</span>"
                    cClass = ''
                    down_score_type=1
                    i1 = require("../../../assets/images/tran/220301/tj_icon.png")
                }else {
                    if(res.payScore <= 0) {
                        cClass = ''
                    }else {
                        cClass = 'disabledSty'
                    }
                    c = "余额：0积分"
                    if(res.userVipPage > 0) {
                        i2 = require("../../../assets/images/tran/220301/tj_icon.png")
                    }
                } 
                
                str = `<div class="select-pay-type-cont">
                            <!-- 积分选择 -->
                            <div class="score-type-cont">
                                <div class="${cClass} score-type sameOperate" data-type="3">
                                    <i class="iconfont iconoval"></i>
                                    <span>积分结算</span>
                                    <span class="score_pages_num">${c}</span>
                                    <img src="${i1}" alt="">
                                </div>
                            </div>
                            <!-- 页数选择 -->
                            <div class="pages-type-cont">
                                <div class="${aClass} vip-type sameOperate" data-type="1">
                                    <i class="iconfont iconoval"></i>
                                    <span>VIP页结算</span>
                                    <span class="vip_pages_num">${a}</span>
                                    <img src="${i2}" alt="">
                                </div>
                                <div class="${bClass} special-type sameOperate" data-type="2">
                                    <i class="iconfont iconoval"></i>
                                    <span>特惠页结算</span>
                                    <span class="special_pages_num">${b}</span>
                                </div>
                            </div>

                        </div>

                        <p class="s_p_t_p2">
                            <span class="single_pay" style="display: none">单次付费</span>
                            <span class="pay_num"></span> 
                        </p>
                        <div class="btns">
                            <button class="singlePayNow" disabled="true">立即充值</button>
                            <button class="singleTransNow" disabled="true">立即下载</button>
                        </div>`
                $(".s-p-loading").hide()
                $(".pay-types-cont").html(str)
				if(!this.data.isShowSingle){
					$(".single_pay").remove()
				}
                // 三个余额都为0时
                if(res.userVipPage <= 0 && res.userSpecialPage <= 0 && res.userAllScore <= 0) {
                    $(".single_pay").css("display","block")
                    $(".singlePayNow").css({
                        "opacity":"1",
                        "cursor":"pointer"
                    }).removeAttr("disabled");
                    singlePayType = 1
                }
                // 只有一种余额时默认勾选
                // 默认vip
                if(res.userVipPage > 0&&res.userSpecialPage <= 0&&res.userAllScore <= 0) {
                    $(".vip-type .iconoval").addClass('iconxuanzhong1').removeClass('iconoval')
                    $(".pages-type-cont").addClass('active')
                    if(res.payPage > res.userVipPage) {
                        payTypes = -1
                        _comMeds.autoCloseAlert("余额不足请选择组合支付方式!");
                        $(".singleTransNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".singlePayNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".pay_num").html('')
                    }else {
                        reduceCode = 3
                        $(".singleTransNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".singlePayNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="vipy">'+ res.payPage +'</span><em>vip页</em>'+ freeStr +'')
                    }
                }
                // 默认特惠页
                if(res.userSpecialPage > 0&&res.userVipPage <= 0&&res.userAllScore <= 0) {
                    $(".special-type .iconoval").addClass('iconxuanzhong1').removeClass('iconoval')
                    $(".pages-type-cont").addClass('active')
                    if(res.payPage > res.userSpecialPage) {
                        payTypes = -2
                        _comMeds.autoCloseAlert("余额不足请选择组合支付方式!");
                        $(".singleTransNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".singlePayNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".pay_num").html('')
                    }else {
                        reduceCode = 2
                        $(".singleTransNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".singlePayNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="thy">'+ res.payPage +'</span><em>特惠页</em>'+ freeStr +'')
                    }
                }
                // 默认积分
                if((res.userAllScore > 0&&res.userVipPage <= 0&&res.userSpecialPage <= 0) ||scoreOrPages==1||down_score_type==1) {
                    $(".score-type .iconoval").addClass('iconxuanzhong1').removeClass('iconoval')
                    $(".score-type-cont").addClass("active")
                    if(res.payScore > res.userAllScore) {
                        payTypes = 0
                        _comMeds.autoCloseAlert("余额不足，请立即充值!");
                        $(".singleTransNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".singlePayNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".single_pay").css("display","block")
                        singlePayType = 1
                        $(".pay_num").html('')
                    }else {
                        reduceCode = 1
                        $(".singleTransNow").css({
                            "opacity":"1",
                            "cursor":"pointer"
                        }).removeAttr("disabled");
                        $(".singlePayNow").css({
                            "opacity":"0.2",
                            "cursor":"default"
                        }).attr("disabled","true");
                        $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="jf">'+ res.payScore +'</span><em>积分</em>')
                        
                    }
                }
                // 点击选择页数付费方式
                $(".sameOperate").unbind("click").bind("click", function (e) { 
                    console.log(88888888888) 
                    e.stopPropagation()
                    e.preventDefault() 
                    let type = $(this).data("type")
                    console.log(type)

                    if(!$(this).find('i').hasClass('iconxuanzhong1')) {
                        $(".sameOperate").each(function () {  
                            $(this).find("i").removeClass('iconxuanzhong1').addClass('iconoval')
                            $(this).parent().removeClass('active')
                        })
                        $(this).find('i').addClass('iconxuanzhong1').removeClass('iconoval')
                        $(this).parent().addClass('active')
                    }

                    // 页数判断vip
                    if(type == 1) {
                        $(".single_pay").css("display","none")
                        // vip页数
                        if(payTypes == -2) {//先点击特惠页数不够
                            $(".pages-type-cont .sameOperate").each(function () {  
                                $(this).find("i").addClass('iconxuanzhong1').removeClass('iconoval')
                                $(this).css("pointer-events","none")
                            })
                            if(res.payPage > res.userSpecialPage + res.userVipPage) {
                                _comMeds.autoCloseAlert("余额不足，请立即充值!");
                                $(".singleTransNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".singlePayNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".single_pay").css("display","block")
                                singlePayType = 4
                                $(".pay_num").html('')
                            }else {
                                reduceCode = 4
                                $(".singleTransNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".singlePayNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                let num = res.payPage - res.userSpecialPage
                                $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="thy">'+ res.userSpecialPage +'</span><em>特惠页</em>+<span class="vipy">'+ num +'</span><em>vip页</em>'+ freeStr +'')
                            }
                        }else {

                            if(res.payPage > res.userVipPage) {
                                payTypes = -1
                                if(res.userSpecialPage <= 0) {//特惠页为0
                                    _comMeds.autoCloseAlert("余额不足，请立即充值!");
                                    singlePayType = 4
                                    $(".single_pay").css("display","block")
                                }else {
                                    _comMeds.autoCloseAlert("余额不足请选择组合支付方式!"); 
                                }
                                $(".singleTransNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".singlePayNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".pay_num").html('')
                            }else {
                                console.log(res.payPage)
                                reduceCode = 3
                                $(".singleTransNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".singlePayNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="vipy">'+ res.payPage +'</span><em>vip页</em>'+ freeStr +'')
                            }
                        }

                    }
                    // 页数判断特惠
                    if(type == 2) {
                        $(".single_pay").css("display","none")
                        if(payTypes == -1) {//先点击vip页数不够
                            $(".pages-type-cont .sameOperate").each(function () {  
                                $(this).find("i").addClass('iconxuanzhong1').removeClass('iconoval')
                                $(this).css("pointer-events","none")
                            })
                            console.log(res.userSpecialPage + res.userVipPage)
                            if(res.payPage > res.userSpecialPage + res.userVipPage) {
                                _comMeds.autoCloseAlert("余额不足，请立即充值!");
                                $(".singleTransNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".singlePayNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".single_pay").css("display","block")
                                singlePayType = 5
                                $(".pay_num").html('')
                            }else {
                                reduceCode = 5
                                $(".singleTransNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".singlePayNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                let num = res.payPage - res.userVipPage
                                $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="vipy">'+ res.userVipPage +'</span><em>vip页</em>+<span class="thy">'+ num +'</span><em>特惠页</em>'+ freeStr +'')
                            }
                        }else {

                            if(res.payPage > res.userSpecialPage) {
                                payTypes = -2
                                if(res.userVipPage <= 0) {//vip页为0
                                    _comMeds.autoCloseAlert("余额不足，请立即充值!");
                                    singlePayType = 5
                                    $(".single_pay").css("display","block")
                                }else {
                                    _comMeds.autoCloseAlert("余额不足请选择组合支付方式!"); 
                                }
                                $(".singleTransNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".singlePayNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".pay_num").html('')
                            }else {
                                reduceCode = 2
                                $(".singleTransNow").css({
                                    "opacity":"1",
                                    "cursor":"pointer"
                                }).removeAttr("disabled");
                                $(".singlePayNow").css({
                                    "opacity":"0.2",
                                    "cursor":"default"
                                }).attr("disabled","true");
                                $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="thy">'+ res.payPage +'</span><em>特惠页</em>'+ freeStr +'')
                            }
                        }

                    }
                    // 积分判断
                    if(type == 3) {
                        $(".single_pay").css("display","none")
                        payTypes = 0
                        $(".pages-type-cont .sameOperate").each(function () {  
                            if(!$(this).hasClass("disabledSty")) {
                                $(this).css("pointer-events","all")
                            }
                        })
                        if(res.payScore > res.userAllScore) {
                            _comMeds.autoCloseAlert("余额不足，请立即充值!");
                            $(".singleTransNow").css({
                                "opacity":"0.2",
                                "cursor":"default"
                            }).attr("disabled","true");
                            $(".singlePayNow").css({
                                "opacity":"1",
                                "cursor":"pointer"
                            }).removeAttr("disabled");
                            $(".single_pay").css("display","block")
                            singlePayType = 1
                            $(".pay_num").html('')

                        }else {
                            reduceCode = 1
                            $(".singleTransNow").css({
                                "opacity":"1",
                                "cursor":"pointer"
                            }).removeAttr("disabled");
                            $(".singlePayNow").css({
                                "opacity":"0.2",
                                "cursor":"default"
                            }).attr("disabled","true");
                            $(".pay_num").html('本次共下载<span>'+ filesNum +'</span>个文档，需扣除<span class="jf">'+ res.payScore +'</span><em>积分</em>')
                        }
                    }
                    
                })
                
                // 点击立即下载
                $(".singleTransNow").unbind("click").bind("click",_comMeds.throttle(function(e) {
                    _this.batchDownloadDeductFuc(id, reduceCode, filestype)
                }))

                // 点击单次付费
                $(".single_pay").click(function() {
                    // window.location = winPubPath + '/pay/singlePay.html?tid='+id+'&payItemCode='+filestype+'&payWay='+singlePayType;
					let a = {
						tid: id,
						payItemCode: filestype,
						payWay: singlePayType,
					}
					sessionStorage.setItem("singlePayInfo",JSON.stringify(a))
					let payObj = {
						payTab: 6,
						payIndex: 1,
						payFrom: 0,
					}
					_allPayBox.payBox(payObj,function(){
						if($(".tab_boxs.active").data("num") == 6){
							// window.location.href = winPubPath + '/person/myfiles.html';
							if(String(id).indexOf(",") != -1) {//单文件下载
								_this.downloadAllTrans(id,filestype,1)
							}else {
								_this.downLoad(id,filestype,1)
							}
						}else{
							$(".r-c-box.active .radio-choose").click()
						}
					});
                })

                // 点击立即充值
                $(".singlePayNow").unbind("click").bind("click",_comMeds.throttle(function(e){
                    let isVip = JSON.parse(localStorage.getItem('userInfo')).memberStatus.memberType.memberType
                    console.log(isVip ,reduceCode)
					let payObj = {
						payTab: 2,
						payIndex: 0,
						payFrom: 0,
					}
                    if(reduceCode == 1) {
						payObj.payTab = 2
                        _allPayBox.payBox(payObj,function(){
							$(".r-c-box.active .radio-choose").click()
						})
                    }else {
                        if(isVip == 'month') {
							payObj.payTab = 4
                            _allPayBox.payBox(payObj,function(){
								$(".r-c-box.active .radio-choose").click()
							})
                        }else {
							payObj.payTab = 1
                            _allPayBox.payBox(payObj,function(){
								$(".r-c-box.active .radio-choose").click()
							})
                        }
                    }
                    
                }))


            })
        }

    },
    // 检查积分/页数是否够扣(单文件下载扣费)
    officalWebsiteFuc(id, type, downType) {
        let _this = this
        let subData = {
            pdfId: id,
            payItemCode: downType,
            scoreReduceCode: type
        }
        _score.officalWebsite(subData, res => {
            
        }, res => {
            if(res.code == '2010001' || res.code == '2010007' || res.code == '2010017') {
                if(res.data.isEnough == 1) {
                    _score.reduceScoreReq(subData, data => {
                        // 扣分成功
                        _this.downLoad(id,downType,1)
                    })
                }else {
                    _comMeds.autoCloseAlert(res.msg)
                }
            }else {
                _comMeds.autoCloseAlert(res.msg)
            }
        })
    },
    // 批量下载扣费
    batchDownloadDeductFuc(id, type, downType) {
        let _this = this
        let subData = {
            pdfIds: id,
            downloadType: downType,
            deductType: type
        }
        _score.batchDownloadDeduct(subData, res => {
            _this.downloadAllTrans(id,downType,1)
        }, res => {
            _comMeds.autoCloseAlert(res.msg)
        })
    },
    // 真正下载(单文件)
	downLoad : function(id,type,isPay){
		let downType;
		if (type == 200) {//pdf
			downType = 1;
		}else if(type == 300){
			downType =2;
		} else if(type == 400){
			downType =3;
		}
		let subData = {
			tid:id,
			downType:downType
		};
		_tran.getDownUrl(subData, function(res,msg){
			console.log(res.docUrl);
            _comMeds.messageDataFunnel(5)
			window.location = res.docUrl;
            if(isPay) {//1需要付费
                $(".mytran-box").show()
                $(".select-box").hide()
            }

		},function(res){
			_comMeds.autoCloseAlert(res.msg);
            setTimeout(function() {
                location.reload()
            },500)
		})
		$(".common-shadow-bg").remove();

		$("input[type=checkbox]").prop("checked",false);
		this.data.chooseIds = [];
		$(".my-tran-box").hide();
		$(".maintable .operate-box").show();
	},
    // 真正下载(多文件)
	downloadAllTrans : function(id,type,isPay){
		let downType;
		if (type == 200) {
			downType = 1;
		}else if(type == 300){
			downType =2;
		} else if(type == 400){
			downType =3;
		}
		let subData = {
			tids:id,
			downType:downType
		};
		// var newWindow = window.open();
		_tran.getMultiDownUrl(subData, function(res,msg){
			// _comMeds.getDownFile(res.docUrl)
            window.location = res.docUrl;
            if(isPay) {//1需要付费
                $(".mytran-box").show()
                $(".select-box").hide()
            }
		},function(res){
			_comMeds.autoCloseAlert(res.msg);
            setTimeout(function() {
                location.reload()
            },500)
		})

		/*let down_url = _comMeds.getServerUrl('sdoc/web/multiDownDoc');
		let form = $("<form style='display:none;' target='' method='post' action="+down_url+">");
		let input_str = '<input type="hidden" name="tids" value="'+id+'" />'
					+'<input type="hidden" name="downType" value="'+downType+'" />'
					+'<input type="hidden" name="deviceType" value="web" />'
					+'<input type="hidden" name="deviceId" value="'+_comMeds.getDeviceId()+'" />';
		$("body").append(form);
		form.append(input_str);
		form.submit();*/
		$(".common-shadow-bg").remove();

		$("input[type=checkbox]").prop("checked",false);
		this.data.chooseIds = [];
		$(".my-tran-box").hide();
		$(".maintable .operate-box").show();
	},
	// 根据等级获取回收站权限
	getLevel : function(){
		let _this = this;
		_vip.getIndexUserInfoNew({}, function(res) {
			_this.data.timeReqCount++;
			if (res) {
				_this.showRabageLevel(res);

				// 两个接口同时返回时
				// if (_this.data.timeReqCount == '2' && _this.data.expireCount > 0) {
				// 	_this.fileExpericeBox(_this.data.expireCount, _this.data.recentExpireDay);
				// }
			}
		},function(res){
			$(".question-box .huishou-tip").hide();
		})
		_tran.getDocActivityModel({}, function (res) {
			if (res.length) {
				let data = JSON.parse(JSON.stringify(res))
				// let data = ["DEEPL"]
				if (data.indexOf("DEEPL") == -1) {
					$(".erji-myfile div[data-type='1']").hide()
				}
				if (data.indexOf("OPENAI") == -1) {
					$(".erji-myfile div[data-type='3']").hide()
				}
				if (data.indexOf("GOOGLECLOUD") == -1) {
					$(".erji-myfile div[data-type='2']").hide()
				}
			}
		}, function (res) {

		})
	},
	// 更换回收站提示语
	showRabageLevel : function(res){ 
        let _this = this
		let doc_time = res.memberAuthority.saveTime;
		let rec_time = res.memberAuthority.rubbishTime;
		_this.data.rubbishTime = rec_time;
		if(doc_time == -1){
			$(".top-toggle .message-tip").text(`文档永久存储,回收站存储时长${rec_time}天`);
		}else{
			$(".top-toggle .message-tip").text(`文档存储时长${doc_time}天,回收站存储时长${rec_time}天`);
		}
	},
	// 回收站中恢复图片提示
	restoreImg : function(id){
		let _this = this;
	    var str = '<p style="padding:30px 26px;">确认恢复选中的图片吗？</p>';

	    _comMeds.zgAlert({
	        title:'提示',
	        content:str,
	        width:'440px',
	        noText:'取消',
	        yesText:'确定',
	        yesFn:function(e){
	            let subData = {
	            	taskId:id
	            };
	            _tran.recoverImage(subData,function(res){
			        $('.maintable').dataTable().fnDraw(false);
		        	_comMeds.autoBlueBox("恢复成功",1);
		        },function(res){
		        	_comMeds.autoBlueBox("恢复失败",2);
		        })
	            $(".common-shadow-bg").remove();
	        },
	        noFn:function(e){
	            $(".common-shadow-bg").remove();
	        },
	        closeFn:function(e){
	            $(".common-shadow-bg").remove();
	        }
	    });
	},
	// 彻底删除回收站图片
	delMyRecycleImg : function(id){
		let _this = this;
		let subData = {
			taskId:id
		};
		let str = '<div style="font-size: 16px;margin-top:30px;margin-bottom:13px;">确定删除所选图片？</div>'
				+'<div class="red" style="font-size:18px;margin-bottom:23px;">图片彻底删除后无法恢复！</div>';

		_comMeds.zgAlert({
		    title:'提示',
		    content:str,
		    width:'440px',
		    yesText:'确定',
		    noText:'取消',
		    yesFn:function(e){
		    	_comMeds.autoBlueBox("正在删除中",3);
		        _tran.delRecycleImage(subData, function(res,msg){
		        	$('.maintable').dataTable().fnDraw(false);
		        	_comMeds.autoBlueBox("删除成功",1);
		        },function(res){
		        	_comMeds.autoBlueBox("删除失败",2);
		        })
		        $(".common-shadow-bg").remove();
		    },
		    noFn:function(e){
		        $(".common-shadow-bg").remove();
		    },
		    closeFn:function(e){
		        $(".common-shadow-bg").remove();
		    }
		});
	},

	// 获取pdf文件列表
	getPdfList: function(node) {
		let _this = this;
		let matchIdCount = 0;
		_this.data.chooseIds = [];
		$(".my-tran-box").hide();
		$(".del-box").hide();

		$('.maintable').DataTable({
			autoWidth:false, // 控制Datatables是否自适应宽度
			info: true, // 控制是否显示表格左下角的信息
			lengthChange:false, // 是否允许用户改变表格每页显示的记录数
			lengthMenu:[10], // 显示几项结果
			ordering:false, // 是否允许Datatables开启排序
			serverSide:true, // 是否开启服务器模式
			dom: 't<"table-bottom-box clearfix"i<"select-page"l>p>',
			stateSave: false, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
			searching:true, // 是否允许Datatables开启本地搜索
			columns: [
				{
					data: null,
					title:'<label class="check-box all-check"><input type="checkbox" name="total-check" class="total-check" /></label>',
					width:'4%',
					className:'align-left',
					render: function(data, type, row, meta){
						let input_item = '';
						if (row.status == '0') {
							input_item = '<input type="checkbox" class="no-choose" disabled="disabled" data-id="'+row.id+'" />';
						}else{
							if ($.inArray(row.id,_this.data.chooseIds) != -1){

                                input_item = '<input type="checkbox" checked="true" class="can-choose" data-id="'+row.id+'" />';
								matchIdCount++;
								if (matchIdCount == 10) {
									$(".total-check").prop("checked",true);
								}
							}else{

                                input_item = '<input type="checkbox" class="can-choose" data-id="'+row.id+'" />';
								$(".total-check").prop("checked",false);
							}
						}

						var content = '<label class="check-box check-item">'
								+input_item
								+'</label>';
						return content;
					}
				},
				{
					title:"文档名",
					data: 'title',
					width:'25%',
					className:'align-left img-td',
					render: function(data, type, row, meta){
						let file_type = _comMeds.getFileExtendingName(row.docType);
						let img_url = require("../../../assets/images/tran/translate_list_" + file_type + "@2x.png");
						let img_src = "<img class = 'file-img' src = "+img_url+">";
						let file_name = "<p class='file-name'>"+data+"."+row.docType+"</p>";
						return img_src + file_name;
					}
				},
				{
					title:'页数<div class="question-box"><span class="iconfont iconwenhao page-tip"><span class="message-tip">Word、PDF、PPT按原页数计算；Excel、TXT、HTML、图片、CAD翻译每2000字符为1页</span></span></div>',
					width:'8%',
					className:'align-left',
					data: 'pageCount',
					render:function(data,type,row,meta){
						return '<div class="page-num-'+row.id+'">'+data+'页</div>';
					}
				},
				{
					title:"转换格式",
					data: 'fromLanguage',
					width:'15%',
					className:'align-left',
					render: function(data, type, row, meta){
                        let str = ''
                        if(row.convertType == '-13'){
                            str = '<p>合并pdf</p>';

                        }else if(row.convertType == '-14') {
                            str = '<p>拆分pdf</p>';

                        }else {
                            str = '<p>'+(row.docType).toUpperCase()+'<span class="iconfont iconjiantouyou item-jiantou"></span>'+(row.conversionFormat).toUpperCase()+'</p>';
                        }
						return str;
					}
				},
				{
					title:"状态",
					width:'15%',
					className:'align-left',
					data: 'status',
					render:function(data,type,row,meta){
						let tran_icon = '';
						let tran_text = '';
						let timeout_str = '';
						let detail_str = '';
                        
						if (row.status == "0"){
							// 等待或正在翻译中
							if (row.rank >= '1') {
								// 排队
								tran_icon = '<span class="icon-tip icon-wait"></span>';
								tran_text = '<span class="tran-status-text">正在排队，前面还有'+row.rank+'人</span>';
							}else{
								if (row.model >= 119 && row.model < 130 && row.docType == 'pdf') {
									if (row.displayUpSpeedStatus != 1 || row.displayUpSpeedStatus != 2) {
										// detail_str = '<span class="tran-detail"><span class="tran-detail-text">详情</span><span class="iconfont icondown"></span></span>';
									}
								}
								
								tran_icon = '<span class="icon-tip icon-wait"></span>';
								if (row.percent > 99) {
									row.percent = 100;
								}
								tran_text = '<span class="tran-status-text">已转换'+row.percent+'%</span>'+detail_str
										+'<span class="translate-status" style="width: ' + row.percent * 1080 / 100 + 'px"></span>';
							}

							_this.data.table_timer[meta.row] = setInterval(function(){
								_this.queryTranslatePdf(row.id,meta.row);
							}, 2000);
						}else if (row.status == "1") {
							// 翻译成功
							if (row.pdfDownloadAction == '1' || row.wordDownloadAction == '1') {
								tran_icon = '<span class="icon-tip icon-down"></span>';
								tran_text = '<span class="tran-status-text">已下载</span>';
							}else{
								tran_icon = '<span class="icon-tip icon-finish"></span>';
								tran_text = '<span class="tran-status-text">已完成</span>';
							}
						}else if(row.status == "3"){
							// 校对中
							if (row.subNumber == "1") {
								// 查询
								/*_this.data.table_timer = setInterval(function(){
									_this.queryTranslateDoc(row.id);
								}, 2000);	*/						
							}
							tran_icon = '<span class="icon-tip icon-wait"></span>';
							tran_text = '<span class="tran-status-text">校对中</span>';
						}else if(row.status == "-11"){
							// 已取消
							tran_icon = '<span class="icon-tip icon-cancel"></span>';
							tran_text = '<span class="tran-status-text">已取消</span>';
						}else if(row.status == "-12" || row.status == "-10"){
							// 人工处理
							tran_icon = '<span class="icon-tip icon-fail"></span>';
							tran_text = '<span class="tran-status-text">转换失败</span>'
									+'<span class="iconfont iconwenhao fail-tip-icon">'
									+'<span class="fail-tip-text">'+row.msg+'</span>'
									+'</span>';
						}else if(row.status == "-13"){
							// 未读取到需要翻译的内容
							tran_icon = '<span class="icon-tip icon-fail"></span>';
							tran_text = '<span class="tran-status-text">转换失败</span>'
									+'<span class="iconfont iconwenhao fail-tip-icon">'
									+'<span class="fail-tip-text">'+row.msg+'</span>'
									+'</span>';
						}else{
							tran_icon = '<span class="icon-tip icon-fail"></span>';
							tran_text = '<span class="tran-status-text">转换失败</span>'
									+'<span class="iconfont iconwenhao fail-tip-icon">'
									+'<span class="fail-tip-text">'+row.msg+'</span>'
									+'</span>';
						}
                        

						let status = '<p data-id="'+row.id+'" class="status-'+row.id+'">'+tran_icon+tran_text+'</p>';
						let create_time = '<p class="create-time">'+row.createTime+'</p>';

						// 显示剩余天数
						let a = JSON.parse(localStorage.getItem("userInfo")).memberStatus.memberType.memberType
                        if(a != "month") {
                            if (row.remainStorageDays >= 0 && row.remainStorageDays <= 7) {
                                timeout_str = '<div class="remain-time time-'+row.id+'">剩余时长：'+row.remainStorageDays+'天</div>';
                            }
                        }
						return status + create_time + timeout_str;
					}
				},
				{
					title:"操作",
					width:'13%',
					className:'align-left',
					data: 'info',
					render:function(data,type,row,meta){
						let operate_item = '';

				
						if (row.status == 1) {
							// 翻译成功
							if (row.pdfDownloadAction == '1' || row.wordDownloadAction == '1'){
								operate_item = '<span class="down-pdf">再次<br/>下载</span>'
												+'<span class="del-doc" style="top:-6px;">删除</span>';
							}else{
								operate_item ='<span class="down-pdf">下载</span>'
												+'<span class="del-doc">删除</span>';
							}
						}else if(row.status == '0'){
							// 正在翻译中
							
							// operate_item = '<span></span>';
						}else {
							operate_item = '<span class="del-doc">删除</span>';
						}
                        let operate_str = ''
                        if(row.docType == 'pdf') {
                            operate_str = '<p class="operate-box table-item-'+row.id+'" data-id="'+row.id+'" data-type="'+row.docType+'" data-index="'+meta.row+'">'
                            +operate_item
                            +'</p>';
                        }else {
                            operate_str = '<p class="operate-box2 table-item-'+row.id+'" data-id="'+row.id+'" data-type="'+row.docType+'" data-index="'+meta.row+'">'
                            +operate_item
                            +'</p>';
                        }

						return operate_str;
					}
				}
			],
			ajax: function (data, callback, settings) {
				//封装相应的请求参数，这里获取页大小和当前页码
				var pagesize = data.length;//页面显示记录条数，在页面显示每页显示多少项的时候,页大小
				var start = data.start;//开始的记录序号
				var page = (data.start) / data.length + 1;//当前页码
				matchIdCount = 0;

				// 翻页清除前一页的定时器
				for(var i = 0; i <= _this.data.table_timer.length; i++){
				    clearInterval(_this.data.table_timer[i]);   
				}
				if ($(".pro-detail-box")) {
					$(".pro-detail-box").remove();
				}
				if(node == '11'){
					let docSource;
					if(_this.data.node == '1'){
						docSource = 0
					} else if(_this.data.node == '3'){
						docSource = -2
					} else if(_this.data.node == '7'){
						docSource = -3
					}
					let subData = {
						page:page,
						title:$(".search-input").val(),
						rows:10,
						docSource:docSource
					};
					_tran.getExpireDocList(subData, function(res,msg){
						let returnData = {};
						if (res.total === 0) {
							$(".table-bottom-box").hide();
							$(".empty-box").show();
						}else{
							$(".empty-box").hide();
						}
						returnData.recordsTotal = res.total;
						returnData.recordsFiltered = res.total;
						returnData.data = res.list;
						callback(returnData);
					},function(res){
						_comMeds.autoCloseAlert(res.msg);
					})
				} else {
					let subData = {
						page:page,
						handleType: 3,
						title:$(".search-input").val()
					};
					_pdf.getMyTranslate(subData, function(res,msg){
						let returnData = {};
						if (res.total === 0) {
							$(".table-bottom-box").hide();
							$(".empty-box").show();
						}else{
							$(".empty-box").hide();
						}
						returnData.recordsTotal = res.total;
						returnData.recordsFiltered = res.total;
						returnData.data = res.list;

						callback(returnData);
					},function(res){
						_comMeds.autoCloseAlert(res.msg);
					})
				}
			},
		});
	},
    // 下载pdf转换文件
	deletePdfConverterFile(id, type){
		let formData = new FormData();
        let _this = this

        formData.append("deviceType",'web');
        formData.append("deviceId",_comMeds.getDeviceId());
        formData.append("tid",id);

        $.ajax({
            type: 'POST',
            url: _comMeds.getServerUrl('sdoc/pdfConverter/downloadPdfConverterFile'),
            dataType: 'json',
            data: formData,
            processData:false,
            contentType:false,
            success: function (res) {  
                if(type == 'pdf') {
                    // window.open(res.data.docUrl)
                    // window.location = res.data.docUrl;
					_comMeds.getDownFile(res.data.docUrl)
                }else {
                    if(res.code == '-6000035') {//么有付款
                        _this.getPdfOtherPay(id)
                    }else if(res.code  == '0') {
                        // window.open(res.data.docUrl)
                        // window.location = res.data.docUrl;
						_comMeds.getDownFile(res.data.docUrl)
                    }
                }
            }
        })
        // let form = form =  $("<form style='display:none;' target='' method='post' action="+url+">");
        // let input_str = '<input type="hidden" name="tid" value="'+id+'" />'
        //               + '<input type="hidden" name="deviceType" value="web" />'
		// 			  +'<input type="hidden" name="deviceId" value="'+_comMeds.getDeviceId()+'" />';
		// $("body").append(form);
		// form.append(input_str);
        // form.submit();
	},
    getPdfOtherPay(id) {
        let _this = this;
        let taskId = id.toString()
        let subData = {
            taskId: taskId
        }
        _ofd.getPdfOtherPay(subData, function(res){
            if(res.type == 0){
                _this.getTransNowofd(taskId);
            } else if(res.type == 1){
                _this.payMoneyBox(res, taskId);
            }
        },function (res) {  
            if(res.code == '-6000042') {
                _comMeds.autoCloseAlert(res.msg); 
            }
        })
    },
    payMoneyBox(data, id) {
        $('.common-shadow-bg').remove();
        let _this = this;
        let p;
        let payCount = data.totalCount - data.disCount;
        if(data.disCount == 0) {
            p = ''
        } else {
            p = '<p class="flex-p">优惠页数：<span class="right free-page">-'+data.disCount+'</span></p>'
        }
        let str = '<div class="pay-box">'
                + '<div class="pay-top">'
                + '<p class="flex-p">总页数：<span class="right">'+data.totalCount+'</span></p>'
                + p
                + '</div>'
                + '<div class="pay-bottom">'
                + '<p class="flex-p">待支付页：<span class="right total-zero-page">'+data.payCount+'页（0.1元/页,<span>0.3元/页</span>）</span></p>'
                + '<p class="total-count">合计：<span>¥<span>'+data.payCount+'</span></span></p>'
                + '</div>'
                + '<div class="btn-wrapper">'
                + '<button class="wx-pay-btn">微信支付</button>'
                + '<button class="zfb-pay-btn">支付宝</button>' 
                + '</div>'
                + '</div>'
        _comMeds.zgAlert({
            title: '确认转换费用',
            content: str,
            emptyText: true,
            closeFn: function (e) {
                $('.common-shadow-bg').remove();
                _comMeds.countLink(42,5);
            }
        })
        // 点击微信支付
        $('.wx-pay-btn').on('click', function(){
            _this.ofdSinglecharge(id, 2, data.payCount);
            _comMeds.countLink(41,5);
        })

        // 点击支付宝支付
        $('.zfb-pay-btn').on('click', function(){
            _this.ofdSinglecharge(id, 1, data.payCount);
            _comMeds.countLink(41,5);
        })
    },
    ofdSinglecharge(id, way, money) {
        let _this = this;
        let subData = {
            pdfId: id,
            payItemCode: 800,
            way: way
        }
       _ofd.ofdSinglecharge(subData, function(res) {
           clearInterval(_this.data.timer);
           if(way == 1) {  // 支付宝弹框
              _this.aliPayWrap(res, money);
              _this.data.timer = setInterval(() => {
                 _this.query(res.outTradeNo, id);
              }, 3000);
           } 
           if(way == 2){  // 微信弹框
              _this.weixinPayWrap(res, money);
              _this.data.timer = setInterval(() => {
                  _this.query(res.outTradeNo, id);
              }, 3000);
           }
       }, function(res){
           if(res.code == -3000004 || res.code == -3000016){
            //    _this.xieyiTip(id, way, money);
               xieyiBox().then(function(){
                   $('.common-xieyi-bg').remove();
                  _this.ofdSinglecharge(id, way, money);
               })
           }
       })
    },
    // 微信支付弹窗
    weixinPayWrap(data, money) {
        let _this = this;
        if($(".alipay-pay-box").length > 0){
            $(".alipay-pay-box").remove();
        }
        let str = `<div class="common-alert-box alipay-pay-box" style="width:660px;">
                    <div class="iconfont iconcha close-icon close"></div>
                    <div class="pay-container2">
                        <div class="pay-title">请使用微信扫一扫</div>
                        <div class="pay-left-box">
                            <div class="erwei-box">
                                <div id="payQcodeWechat"></div>
                                <div class="pay-logo w-pay-logo"></div>
                            </div>
                            <p class="show-pay-money">¥${money}</p>
                            <p class="pay-tip">请使用微信扫一扫<br/>扫描二维码完成支付</p>
                        </div>
                        <div class="pay-bg wexpay-bg"></div>
                    </div
                </div>`;
        $("body").append(str);
        let qrcode = new QRCode('payQcodeWechat', {
            render: "canvas",
            width: 156,
            height: 156,
            text: data.data
        });
        $(".alipay-pay-box .close").click(function(){
            $(".alipay-pay-box").remove();
        })
    },
    // 支付宝弹窗
    aliPayWrap(data, money){
        let _this = this;
        if($(".alipay-pay-box").length > 0){
            $(".alipay-pay-box").remove();
        }
        let str = `<div class="common-alert-box  alipay-pay-box" style="width:660px;">
                    <div class="iconfont iconcha close-icon close"></div>
                    <div class="pay-container2">
                        <div class="pay-title">请使用支付宝扫一扫</div>
                        <div class="pay-left-box">
                            <div class="erwei-box">
                                <div id="payQcodeAli"></div>
                                <div class="pay-logo a-pay-logo"></div>
                            </div>
                            <p class="show-pay-money">¥${money}</p>
                            <p class="pay-tip">请使用支付宝扫一扫<br/>扫描二维码完成支付</p>
                        </div>
                        <div class="pay-bg alipay-bg"></div>
                    </div>
                </div>`;
        $("body").append(str);
        let qrcode = new QRCode('payQcodeAli', {
            render: "canvas",
            width: 156,
            height: 156,
            text: data.data
        });
        $(".alipay-pay-box .close").click(function(){
            $(".alipay-pay-box").remove();
        })
    },
    // 查询微信订单状态
    query : function(outTradeNo, id){
        let _this = this;
        let subData = {
            outTradeNo: outTradeNo
        };
        _pay.queryOrder(subData, function(res){
            $(".alipay-pay-box").remove();
            $('.common-shadow-bg').remove();
            clearInterval(_this.data.timer);
            _this.data.timer = null;
            _this.deletePdfConverterFile(id, _this.data.typeId)
           _this.getTransNowofd(id);
        }, function(res){
            if (res.code == '-3000016') {
                clearInterval(_this.data.timer);
                _comMeds.autoCloseAlert('充值失败，请重试');
            }
            if(res.code == '-3000021'){  // 订单超时
                clearInterval(_this.data.timer);
            }
        });
    },
    // 转换文件
    getTransNowofd(taskId) {
        let _this = this;
         let subData = {
            taskId: taskId,
         }
        _ofd.getTransNowofd(subData, function(res){
            // _this.data.timer = setInterval(function(){
            //     _this.getTransProgress(0,taskId);
            // },1000)
            _this.deletePdfConverterFile(taskId, _this.data.typeId)
        })
    },
    // 查询转换进度
    getTransProgress : function(index, id){
        let _this = this;
        let subData = {
            tid:id
        };
        $("#transTable tr:nth-of-type("+(index+1)+")").find('.cancel-trans').attr('data-id', id);
        _pdf.queryDocProgress(subData, function(res,msg){
            if(res.status == 0){
				res.percent = _comMeds.fomatFloat(res.percent,2)
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.file-status').text('转换中');
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.page-count').text(res.pageCount);
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.conversionFormat').text(res.conversionFormat);
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.file-status-progress').css({width: 1080 * res.percent * 0.01+ 'px'});
            }else if(res.status == 1){
                let image = require('../../../assets/images/tran/icon_finish.png');
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.file-status-progress').hide(); 
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.file-status').text('已完成');
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.file-status-img').attr('src', image);
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.cancel-trans').text('下载').addClass('down-mode').removeClass('cancel-trans');
                clearInterval(_this.data.timer); //清除定时器
            } else if(res.status < 0){  // 转换失败
                let image = require('../../../assets/images/tran/icon_fail.png');
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.file-status-progress').hide(); 
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.file-status').text('转换失败');
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.file-status-img').attr('src', image);
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.cancel-trans').hide();
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.fail-tip-icon').show();
                $("#transTable tr:nth-of-type("+(index+1)+")").find('.fail-tip-text').text(res.msg);
                clearInterval(_this.data.timer); //清除定时器
            }
        },function(res){

        })
    },
	//回收站列表
	getMyRecycleList(type){
		let _this = this;
		let matchIdCount = 0;
		this.data.chooseIds = [];
		_this.data.chooseSource = [];
		$(".timeout-tip").hide();
		$(".my-tran-box").hide();
		$(".del-box").hide();
		$('.maintable').DataTable({
			autoWidth:false, // 控制Datatables是否自适应宽度
			info: true, // 控制是否显示表格左下角的信息
			lengthChange:false, // 是否允许用户改变表格每页显示的记录数
			lengthMenu:[10], // 显示几项结果
			ordering:false, // 是否允许Datatables开启排序
			serverSide:true, // 是否开启服务器模式
			dom: 't<"table-bottom-box clearfix"i<"select-page"l>p>',
			stateSave: false, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
			searching:true, // 是否允许Datatables开启本地搜索
			columns: [
				{
					data: null,
					title:'<label class="check-box all-check"><input type="checkbox" name="total-check" class="total-check" /></label>',
					width:'4%',
					className:'align-left',
					render: function(data, type, row, meta){
						let input_item = '';
						if (row.status == '0') {
							input_item = '<input type="checkbox" class="no-choose" disabled="disabled" data-id="'+row.id+'" data-source="'+row.source+'" />';
						}else{
							if ($.inArray(row.id,_this.data.chooseIds) != -1){
								input_item = '<input type="checkbox" checked="true" class="can-choose" data-id="'+row.id+'" data-source="'+row.source+'" />';
								matchIdCount++;
								if (matchIdCount == 10) {
									$(".total-check").prop("checked",true);
								}
							}else{
								input_item = '<input type="checkbox" class="can-choose" data-id="'+row.id+'" data-source="'+row.source+'" />';
								$(".total-check").prop("checked",false);
							}
						}

						var content = '<label class="check-box check-item">'
								+input_item
								+'</label>';
						return content;
					}
				},
				{
					title:"文档名",
					data: 'title',
					width:'25%',
					className:'align-left img-td',
					render: function(data, type, row, meta){
						let file_type = _comMeds.getFileExtendingName(row.docType);
						let img_url = require("../../../assets/images/tran/translate_list_" + file_type + "@2x.png");
						let img_src = "<img class = 'file-img' src = "+img_url+">";
						let file_name = "<p class='file-name'>"+data+"."+row.docType+"</p>";
						return img_src + file_name;
					}
				},
				{
					title:'页数<div class="question-box"><span class="iconfont iconwenhao page-tip"><span class="message-tip">Word、PDF、PPT按原页数计算；Excel、TXT、HTML、图片、CAD翻译每2000字符为1页</span></span></div>',
					width:'8%',
					className:'align-left',
					data: 'pageCount',
					render:function(data,type,row,meta){
						return '<div class="page-num-'+row.id+'">'+data+'页</div>';
					}
				},
				{
					title:"文件来源<i class='iconfont icondown'></i>",
					data: '',
					width:'15%',
					className:'align-left pdf-file-source',
					render: function(data, type, row, meta){
						let str;
						if(row.source == -1){  // 网站翻译
							str = '网站翻译'
						} else if(row.source == -2){  // 图片翻译
                            str = '图片翻译'
						} else if(row.source == -3){  // 文档转换
                            str = '转换文档'
						} else {
							str = '翻译文档';
						}
						return '<span>'+str+'</span>';
					}
				},
				{
					title:"删除时间",
					width:'15%',
					className:'align-left',
					data: 'recycleTime',
					render:function(data,type,row,meta){
						return   '<span>'+row.recycleTime+'</span>'
					}
				},
				{
					title:"操作",
					width:'13%',
					className:'align-left',
					data: 'info',
					render:function(data,type,row,meta){
						let operate_item = '';
						operate_item ='<span class="restore-doc" data-source="'+row.source+'">恢复</span>'
						             +'<span class="del-doc-recycle" data-source="'+row.source+'">删除</span>';

						let operate_str = '<p class="operate-box table-item-'+row.id+'" data-id="'+row.id+'" data-type="'+row.docType+'" data-index="'+meta.row+'">'
								+operate_item
								+'</p>';
						return operate_str;
					}
				}
			],
			ajax: function (data, callback, settings) {
				//封装相应的请求参数，这里获取页大小和当前页码
				var pagesize = data.length;//页面显示记录条数，在页面显示每页显示多少项的时候,页大小
				var start = data.start;//开始的记录序号
				var page = (data.start) / data.length + 1;//当前页码
				var subData = {
					page:page,
					docSource: type,
					title:$(".search-input").val(),
					recycleType:_this.data.isChooseSystemExprice
				};
				matchIdCount = 0;

				// 翻页清除前一页的定时器
				for(var i = 0; i <= _this.data.table_timer.length; i++){
				    clearInterval(_this.data.table_timer[i]);   
				}
				if ($(".pro-detail-box")) {
					$(".pro-detail-box").remove();
				}

				
				_tran.getMyRecycle(subData, function(res,msg){
					let returnData = {};
					if (res.total === 0) {
						$(".table-bottom-box").hide();
						$(".empty-box").show();
					}else{
						$(".empty-box").hide();
					}
					returnData.recordsTotal = res.total;
					returnData.recordsFiltered = res.total;
					returnData.data = res.list;
					callback(returnData);
				},function(res){
					_comMeds.autoCloseAlert(res.msg);
				})
			},
		});
	},
	// 新人权益翻译 下载提示弹框
	newPeopleDownAlert(params){
		let _this = this,leftPageCode = '',newCode = '';
		let pageCount = params.pageCount;
		// let leftPageCode = pageCount - 20;
		// let newCode = leftPageCode
		// // 这里 乘6 有二个 地方 还有一个在阅读页里
		// if(_comMeds.getFileExtendingName(_this.data.docInfo.docType) == 'cad'){
		// 	newCode = newCode * 6
		// }
		newCode = _this.data.fileStateOjb.computeScoreVo.payCount;
		leftPageCode = _this.data.fileStateOjb.computePageVo.payCount;
		
		let tid = params.id;
		let docType = params.doctype;
		let tip_str = '<div class="common-shadow-bg">'
									+'<div class="newpDownAlert">'
									+'<i class="iconfont iconcha close_downAlert"></i>'
									+`<div class="newPeo_title">翻译未付费，需扣除${leftPageCode}页/${newCode}积分 后可下载</div>`
									+`<p class="newPeo_deste">（此文档共计${pageCount}页，新用户免费翻译20页）</p>`
									+'<button class="newPeo_quitSure">确认扣费</button>'
									+'</div>'
									+'</div>';
		sessionStorage.setItem("novaeHomines", '10')
		$("body").append(tip_str);
		// 关闭弹框
		$("body").on('click','.close_downAlert',function(e){
			$(".common-shadow-bg").remove();
			e.preventDefault();
			e.stopPropagation();
		})
		$("body").on('click','.newPeo_quitSure',function(e){
			$(".common-shadow-bg").remove();
			_this.data.jumpNum = 1
			// 只统计 继续阅读页的数据
			sessionStorage.setItem('onlyGoPageBtn','1')
			_this.getComputeInfo(tid)
		})
	},
	downloadAllPdf : function(id){
		let down_url = _comMeds.getServerUrl('sdoc/pdfConverter/multiDownDoc');
		let form = $("<form style='display:none;' target='' method='post' action="+down_url+">");
		let input_str = '<input type="hidden" name="tids" value="'+id+'" />'
					+'<input type="hidden" name="deviceType" value="web" />'
					+'<input type="hidden" name="deviceId" value="'+_comMeds.getDeviceId()+'" />';
		$("body").append(form);
		form.append(input_str);
		form.submit();
	},
    getWillRestoreDoc() {
		let _this = this;
		_tran.checkRecycle({}, function(res) {
			if(res.docList.length > 0) {
				$('.system-timeout-tip').show();
				$('.system-timeout-tip span').text(res.docList.length);
				$('.erji-huishou').css('top', '150px');
			} else {
				_this.data.isChooseSystemExprice = '';
				$('.system-timeout-tip').hide();
				if ($(".system-timeout-tip .is-check-guoqi").hasClass("iconxuanzhong1")) {
					$(".system-timeout-tip .is-check-guoqi").removeClass("iconxuanzhong1").addClass("iconoval");
				}
				let type2 = $(".erji-huishou div.active").data("type");
				$('.erji-huishou').css('top', '110px');
				_this.getMyRecycleList(type2);
			}
		 if(res.popup == 1) {
				var tip_str = '<div class="common-shadow-bg">'
							+'<div class="will-restore-doc-box">'
							+'<h3>以下文档因过期系统自动加入回收站，至多保留'+res.maxRemainDays+'天，请尽快查看</h3>'
							+'<div class="willRestore-table-box">'
							+ '<table class="willRestoreTable hover row-border"></table>'
							+ '</div>'
							+ '<div class="btn-box">'
							+ '<button class="border-btn see-willRestoreDoc-btn">立即查看</button>'
							+ '</div>'
							+ '</div>'
							 +'</div>';
				$("body").append(tip_str);
				$("body").css("overflow","hidden");
				_this.renderWillRestoreDocTable(res.docList);
				$('.see-willRestoreDoc-btn').on('click', function(){
					$(".common-shadow-bg").remove();
					$(".system-timeout-tip .is-check-guoqi").click();
					$("body").css("overflow","auto");
				})
			}
		})
	},
	renderWillRestoreDocTable(list) {
		let _this = this;
		if ($(".willRestoreTable").hasClass("dataTable")) {
			$(".willRestoreTable").dataTable().fnDestroy();
			$(".willRestoreTable").html('');
		}
		$('.willRestoreTable').DataTable({
			data: list,
			autoWidth:false, // 控制Datatables是否自适应宽度
			info: false, // 控制是否显示表格左下角的信息
			lengthChange:false, // 是否允许用户改变表格每页显示的记录数
			lengthMenu:[10],
			ordering:false, // 是否允许Datatables开启排序
			paging:false, // 是否开启本地分页
			serverSide:false, // 是否开启服务器模式
			pagingType: "simple_numbers",
			dom: 't<"table-bottom-box clearfix"i>',
			stateSave: false, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
			searching:false, // 是否允许Datatables开启本地搜索
			scrollY: "245px",
			scrollCollapse: true,
			columns: [
				{ 
					title: "文档名",
					data: "title",
					width:'100%',
					className:'align-left share-group-name',
				},
			]
		});
	},
	// 文件过期弹窗
	fileExpericeBox(count, time, popRubbishTime){
        // console.log(count, _comMeds.formatTime(time,2))
		// let time_end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime();
		// if (!localStorage.getItem("timeEnd")) {
		// 	localStorage.setItem("timeEnd",time_end);
		// }else{
		// 	let tiem_now = new Date().getTime();
		// 	if (tiem_now < localStorage.getItem("timeEnd")) {
		// 		return false;
		// 	}else{
		// 		localStorage.setItem("timeEnd",time_end);
		// 	}
		// }
		let str = `<div style="font-size: 14px;margin-top:30px;margin-bottom:30px;">过期后文档将在回收站中保留${popRubbishTime}天，届时文档将被删除，<br/>不可找回</div>`;

		_comMeds.zgAlert({
		    title:`您有文档将于${_comMeds.formatTime(time,2)}过期,请及时处理`,
		    content:str,
		    width:'440px',
		    yesText:'立即查看',
		    noText:'知道了',
		    yesFn:function(e){
		    	$(".common-shadow-bg").remove();
		    	$(".timeout-tip .is-check-guoqi").click();
		    },
		    noFn:function(e){
		        $(".common-shadow-bg").remove();
		    },
		    closeFn:function(e){
		        $(".common-shadow-bg").remove();
		    }
		});
	},

	/**
	 * 批量恢复弹框等
	 */
    popRestoreBox(list,single) {
		let _this = this;
		var tip_str = '<div class="common-shadow-bg">'
					+'<div class="restore-box-wrapper">'
					+ '<h3>文档恢复</h3>'
				    +'<div class="restore-box">'
				    + '<table class="restoreTable table row-border"></table>'
					+ '</div>'
					+ '<div class="txt-tip">'
                    + '<div>'
					+ '<p class="total-restore">合计<span class="big-blue total-bean">'+_this.data.needCoins+'</span>个轻寻豆<span class="small-tip">（1轻寻豆/天/文档）</span></p>'
					+ '<p class="remain-bean">剩余轻寻豆：<span class="usable-bean">'+_this.data.userCoins+'</span></p>'
                    + '</div>'
                    +'<div class="is-cycle">VIP会员第2个周期起，免费恢复</div>'
					+ '</div>'
				    + '<div class="btn-box">'
				    + '<button class="border-btn cancel-restoreDoc">取消</button>'
				    + '<button class="blue-btn sure-restoreDoc">确定</button>'
				    + '</div>'
				    + '</div>'
					 +'</div>';
		$("body").append(tip_str);
		$("body").css("overflow","hidden");
		_this.renderRestoreTable(list);

		$('.cancel-restoreDoc').on('click', function() {
			$('.common-shadow-bg').remove();
			$("body").css("overflow","auto");
		})
		$('.sure-restoreDoc').on('click', function() {
			_this.data.recoverDaysArr = [];
			if($(this).hasClass('grey')){
               return false;
			} else {
				let num = $('.total-restore .total-bean').text();
				$.each($('.add-restore-day-input .add-input'), function(i, item){
					let addDay =  Number($(item).val());
					_this.data.recoverDaysArr.push(addDay);
				})
				if(num > 0) {
					_this.sureRestoreBox(num, single);
				} else {
					_this.restoreDocRequest(single);
				}
			}
		})
	},
	renderRestoreTable(list) {
		let _this = this;
        if (list.length >= 0) {
			$(".before-load-table").hide();
        }
        if ($(".restoreTable").hasClass("dataTable")) {
            $(".restoreTable").dataTable().fnDestroy();
            $(".restoreTable").html('');
		}
		$('.restoreTable').DataTable({
		    data: list,
		    autoWidth:false, // 控制Datatables是否自适应宽度
		    info: false, // 控制是否显示表格左下角的信息
		    lengthChange:false, // 是否允许用户改变表格每页显示的记录数
		    lengthMenu:[10],
		    ordering:false, // 是否允许Datatables开启排序
		    paging:false, // 是否开启本地分页
		    serverSide:false, // 是否开启服务器模式
		    pagingType: "simple_numbers",
		    dom: 't<"table-bottom-box clearfix"i>',
		    stateSave: false, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
            searching:false, // 是否允许Datatables开启本地搜索
            scrollY: "245px",
            scrollCollapse: true,
		    columns: [
		        { 
		        	title:"文档名",
		        	data: 'title',
		        	width:'50%',
					className:'align-left',
		        },
		        {
		        	title:'剩余时长',
		        	width:'20%',
		        	className:'align-left',
					data: 'remainStorageDays',
					render: function(data, type, row, meta) {
						if(row.remainStorageDays == 0){
                             return '<span>已过期</span>'
						} else {
                             return '<span>剩余'+row.remainStorageDays+'天</span>'
						}
					}
				},
				{
					title: '操作',
					width: '30%',
					className: 'align-left',
					render: function(data, type, row, meta) {
						let str = '';
						let input_str = '';
						if(row.remainStorageDays == 0){
							input_str = '<input type="number" class="add-input overdue-input" value="1" min="0" max="999" placeholder="1"/>'
									  + '<i class="iconfont add active"></i>'
									  + '<i class="iconfont reduce"></i>'
						} else {
							if(_this.data.userCoins > _this.data.needCoins) {
								input_str = '<input type="number" class="add-input" value="0" min="0" max="999" placeholder="0" />'
								+ '<i class="iconfont add active"></i>'
								+ '<i class="iconfont reduce"></i>'
							} else {
								input_str = '<input type="number"  class="add-input" value="0" min="0" max="999" placeholder="0" />'
									  + '<i class="iconfont add"></i>'
									  + '<i class="iconfont reduce"></i>'
							}
						}
						    str = '<div class="add-restore-day-wrapper">'
								+ '<span>增加存储</span>'
								+ '<div class="add-restore-day-input">'
								+ input_str
								+ '</div>'
								+ '<span>天</span>'
								+ '</div>'
					    return str;
					}
				}
		    ]
		});
	},
	// 再次确认框
	sureRestoreBox(num,single) {
		let _this = this;
		let p = '<p style="margin:100px auto 80px;">确认消耗'+num+'轻寻豆，恢复文档吗？</p>';
		_comMeds.zgAlert({
			title: null,
			content: p,
			yesText: '确定',
			noText: '取消',
			yesFn: function(e){
				_this.restoreDocRequest(single);
			},
			noFn: function(e){
				$('.common-shadow-bg').remove();
				$("body").css("overflow","auto");
				_this.data.recoverDaysArr = [];
			},
			closeFn: function(e){
				$('.common-shadow-bg').remove();
				$("body").css("overflow","auto");
				_this.data.recoverDaysArr = [];
			}
		})
	},
	// 轻寻豆不足弹框
	BeanShortageBox() {
		let _this = this;
		let content = '<div class="bean-shortage-wrapper" style="margin:50px auto;">'
					+ '<p>恢复您选中的文档，至少需要'+_this.data.needCoins+'轻寻豆（1 轻寻豆/天/文档）</p>'
					+ '<p>剩余轻寻豆：'+_this.data.userCoins+'</p>'
					+ '</div>'
			_comMeds.zgAlert({
				title: '轻寻豆不足',
				content: content,
				yesText: '我知道了',
				yesFn: function(e){
					$('.common-shadow-bg').remove();
				},
				closeFn: function(e){
					$('.common-shadow-bg').remove();
				}
			})
	},
	getRecoverDocsInfo(single) {
		let _this = this;
		let subData;
		if(single){
			subData = {
				tidArr: single.id,
				docSourceArr: single.source
			}
		} else {
            subData = {
				tidArr: _this.data.chooseIds.toString(),
				docSourceArr: _this.data.chooseSource.toString(),
			}
		}
		_tran.getRecoverDocsInfo(subData, function(res) {
			_this.data.userCoins = res.userCoins;
			_this.data.needCoins = res.needCoins;
			if(res.enough == 0) {  // 轻寻豆不足够
				_this.BeanShortageBox();
			} else {
				_this.popRestoreBox(res.docList, single);
			}
		}, function(res){
			_comMeds.autoCloseAlert(res.msg);
		})
	},
	restoreDocRequest(single) {
		let _this = this;
		let subData;
		if(!single){
			subData = {
				tidArr: _this.data.chooseIds.toString(),
				docSourceArr: _this.data.chooseSource.toString(),
				recoverDaysArr: _this.data.recoverDaysArr.toString(),
			}
		} else {
			subData = {
				tidArr: single.id,
				docSourceArr: single.source,
				recoverDaysArr: _this.data.recoverDaysArr.toString(),
			}
		}
		_tran.recoverMultiDoc(subData, function(res){
            $('.common-shadow-bg').remove();
			if(res.nextVipShow == 1){
                _comMeds.zgAlert({
					title: '文档恢复成功',
					content: '<p style="height:130px;line-height:130px;">'+res.nextVipShowInfo+'</p>',
					yesText: '我知道了',
					yesFn: function(e){
						$('.common-shadow-bg').remove();
					},
					closeFn: function(e){
						$('.common-shadow-bg').remove();
					}
				})
			} else {
				_this.recoverSuccessTip(res.successCount);
			}
			$('.del-box').hide();
			$('.maintable').dataTable().fnDraw(false);
			_this.getWillRestoreDoc();
			_this.data.recoverDaysArr = [];
			_this.data.chooseIds = [];
			_this.data.chooseSource = [];
			$("body").css("overflow","auto");
		},function(res){
            _comMeds.autoCloseAlert(res.msg);
		})
	},
	tryRecoverDocs(data) {
		let _this = this;
		let subData;
		if(data) {
          subData = {
			  tidArr: data.id,
			  docSourceArr: data.source
		  }
		} else {
            subData = {
				tidArr:  _this.data.chooseIds.toString(),
				docSourceArr: _this.data.chooseSource.toString()
			}
		}
        _tran.tryRecoverDocs(subData, function(res){
			if(res.freeRecover == 0) { //没有免费权益
                if(data){
					_this.getRecoverDocsInfo(data);
				} else {
					_this.getRecoverDocsInfo();
				}
			} else if(res.freeRecover == 1){ // 有免费权益
				$('.maintable').dataTable().fnDraw(false);
				_this.getWillRestoreDoc();
				_this.data.recoverDaysArr = [];
				_this.data.chooseIds = [];
				_this.data.chooseSource = [];
                 _this.recoverSuccessTip(res.successCount);
			}
		})
	},
	recoverSuccessTip(num) {
		let txt;
	   if(num == 1){
          txt = '文档恢复成功，请前往我的文件查看';
	   } else {
          txt = '成功恢复'+num+'个文档请前往我的文件查看'
	   }
	   let str = '<p style="height: 130px;line-height:130px;">'+txt+'</p>'
      _comMeds.zgAlert({
		  content: str,
		  yesText: '我知道了',
		  yesFn: function(e){
			  $('.common-shadow-bg').remove();
		  },
		  closeFn: function(e){
			$('.common-shadow-bg').remove();
		  }
	  })
	},
    /**
	 * 图片批量操作
	 */
	// 批量下载
	downloadAllImg(id){
		let down_url = _comMeds.getServerUrl('scanPen/image/imageDownloadAll');
		let form = $("<form style='display:none;' target='' method='post' action="+down_url+">");
		let input_str = '<input type="hidden" name="taskId" value="'+id+'" />'
		            +'<input type="hidden" name="downloadType" value="2" />'
					+'<input type="hidden" name="deviceType" value="web" />'
					+'<input type="hidden" name="deviceId" value="'+_comMeds.getDeviceId()+'" />';
		$("body").append(form);
		form.append(input_str);
		form.submit();
	}, 
	readload(ids){
		let _this = this;
		let subData = {
            ids
        };
		// 计算够不够
        _score.apiGetComputeInfo(subData, function(res,msg){
			console.log(res)
			
			if(res.computeScoreVo.payStatus == 1 || res.computePageVo.payStatus == 1){
				setTimeout(function() {
					location.reload()
				},500)
			}else{
				if(res.computeScoreVo.isEnough || res.computePageVo.isEnough){
					_comMeds.autoToastPayBox('充值成功')
					_this.reduceTrans(ids)
				}else{
					_comMeds.autoToastPayBoxError('充值余额不足');
				}
			}
			
		},function(res){

        })
	},
	// 扣除翻译需要的积分、页数
	reduceTrans(ids){
		let _this = this;
		let subData = {
            ids,
			// deductType: type
        };
        _score.reduceNewAuthorityTrans(subData, function(res,msg){
			console.log(res)
			// -1余额不足 1 当前传入文档已经付费 0 支付成功
			if(res == 1){
				setTimeout(function() {
					location.reload()
				},500)
			}else if(res == 0){
				setTimeout(function() {
					location.reload()
				},500)
			}else{
				_comMeds.autoToastPayBoxError('充值余额不足');
			}
		},function(res){

        })
	},
}

$(function(){
	_comMeds.eventBus.on('refresh', () => {
		location.reload()
	})
	page.init();
	_tranCommon.init();
	_allPayBox.init();
})
